var _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpainFlag = function SvgSpainFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "69.5 646.5 300 200",
    xmlSpace: "preserve"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C60B1E",
    d: "M69.5 646.5h300v200h-300z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC400",
    d: "M69.5 696.5h300v100h-300z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M136.696 735.396s-.204 0-.316-.064c-.112-.064-.452-.384-.452-.384l-.272-.196-.248-.34s-.292-.472-.16-.836c.136-.364.364-.492.568-.6.204-.104.632-.236.632-.236s.34-.148.452-.168c.112-.024.52-.128.52-.128s.112-.064.224-.108c.116-.044.272-.044.364-.064.088-.024.316-.096.452-.104.208-.008.544.04.656.04.112 0 .496.02.656.02.156 0 .72-.044.88-.044.156 0 .272-.02.452 0 .18.024.496.128.588.172.092.044.632.236.836.3.204.064.7.148.928.256.224.108.364.288.476.44.112.148.136.312.18.42a.763.763 0 0 1 0 .444c-.044.104-.204.324-.204.324l-.248.408-.316.256s-.228.216-.408.192c-.18-.016-2.012-.344-3.188-.344-1.176 0-3.056.344-3.056.344"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    strokeLinejoin: "round",
    d: "M136.696 735.396s-.204 0-.316-.064c-.112-.064-.452-.384-.452-.384l-.272-.196-.248-.34s-.292-.472-.16-.836c.136-.364.364-.492.568-.6.204-.104.632-.236.632-.236s.34-.148.452-.168c.112-.024.52-.128.52-.128s.112-.064.224-.108c.116-.044.272-.044.364-.064.088-.024.316-.096.452-.104.208-.008.544.04.656.04.112 0 .496.02.656.02.156 0 .72-.044.88-.044.156 0 .272-.02.452 0 .18.024.496.128.588.172.092.044.632.236.836.3.204.064.7.148.928.256.224.108.364.288.476.44.112.148.136.312.18.42a.763.763 0 0 1 0 .444c-.044.104-.204.324-.204.324l-.248.408-.316.256s-.228.216-.408.192c-.18-.016-2.012-.344-3.188-.344-1.176 0-3.056.344-3.056.344h.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M139.212 732.772c0-.552.248-.996.552-.996.304 0 .552.444.552.996s-.248 1-.552 1c-.304 0-.552-.448-.552-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M139.212 732.772c0-.552.248-.996.552-.996.304 0 .552.444.552.996s-.248 1-.552 1c-.304 0-.552-.448-.552-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M139.52 732.772c0-.508.112-.92.252-.92.144 0 .256.412.256.92 0 .504-.112.916-.256.916-.14 0-.252-.412-.252-.916"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M139.52 732.772c0-.508.112-.92.252-.92.144 0 .256.412.256.92 0 .504-.112.916-.256.916-.14 0-.252-.412-.252-.916z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M139.4 731.716c0-.192.164-.348.372-.348.2 0 .368.156.368.348 0 .196-.168.348-.368.348-.208 0-.372-.152-.372-.348"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M140.032 731.596v.232h-.572v-.232h.188v-.528h-.248v-.228h.248v-.228h.24v.228h.248v.228h-.248v.528h.144"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.12,
    d: "M140.032 731.596v.232h-.572v-.232h.188v-.528h-.248v-.228h.248v-.228h.24v.228h.248v.228h-.248v.528h.144"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M140.284 731.596v.232h-1.012v-.232h.376v-.528h-.248v-.228h.248v-.228h.24v.228h.248v.228h-.248v.528h.396"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.12,
    d: "M140.284 731.596v.232h-1.012v-.232h.376v-.528h-.248v-.228h.248v-.228h.24v.228h.248v.228h-.248v.528h.396"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M139.876 731.38c.152.044.264.18.264.336 0 .196-.168.348-.368.348-.208 0-.372-.152-.372-.348 0-.16.116-.296.276-.336"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M139.772 735.332h-1.924l-.044-.472-.092-.492-.092-.612c-.532-.7-1.02-1.16-1.184-1.06.04-.128.088-.224.188-.284.472-.28 1.444.392 2.176 1.496.064.1.128.2.184.3h1.588c.056-.1.12-.2.184-.3.728-1.104 1.704-1.776 2.172-1.496.104.06.148.156.188.284-.164-.096-.648.36-1.184 1.06l-.092.612-.092.492-.04.472h-1.936"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M139.772 735.332h-1.924l-.044-.472-.092-.492-.092-.612c-.532-.7-1.02-1.16-1.184-1.06.04-.128.088-.224.188-.284.472-.28 1.444.392 2.176 1.496.064.1.128.2.184.3h1.588c.056-.1.12-.2.184-.3.728-1.104 1.704-1.776 2.172-1.496.104.06.148.156.188.284-.164-.096-.648.36-1.184 1.06l-.092.612-.092.492-.04.472h-1.936z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M136.52 732.676c.364-.212 1.208.456 1.892 1.496m4.62-1.496c-.364-.212-1.204.456-1.892 1.496"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M136.932 736.2a1.867 1.867 0 0 0-.232-.432c.78-.228 1.864-.372 3.068-.376 1.204.004 2.3.148 3.076.376l-.208.364a2.75 2.75 0 0 0-.152.324c-.7-.216-1.608-.324-2.72-.328-1.116.004-2.184.14-2.744.344.008 0-.04-.128-.092-.272h.004"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M136.932 736.2a1.867 1.867 0 0 0-.232-.432c.78-.228 1.864-.372 3.068-.376 1.204.004 2.3.148 3.076.376l-.208.364a2.75 2.75 0 0 0-.152.324c-.7-.216-1.608-.324-2.72-.328-1.116.004-2.184.14-2.744.344.008 0-.04-.128-.092-.272h.004"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M139.768 737.192c.972-.004 2.044-.152 2.44-.252.264-.08.42-.196.392-.336-.016-.064-.072-.12-.148-.152-.584-.188-1.628-.32-2.684-.32-1.052 0-2.108.132-2.688.32-.076.032-.132.088-.148.152-.028.14.128.256.392.336.396.1 1.472.248 2.444.252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M139.768 737.192c.972-.004 2.044-.152 2.44-.252.264-.08.42-.196.392-.336-.016-.064-.072-.12-.148-.152-.584-.188-1.628-.32-2.684-.32-1.052 0-2.108.132-2.688.32-.076.032-.132.088-.148.152-.028.14.128.256.392.336.396.1 1.472.248 2.444.252z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m142.892 735.332-.236-.212s-.228.136-.512.096c-.28-.044-.372-.388-.372-.388s-.316.268-.576.248c-.26-.024-.428-.248-.428-.248s-.284.204-.532.184c-.248-.024-.484-.332-.484-.332s-.252.32-.5.344c-.248.02-.452-.216-.452-.216s-.112.236-.428.288c-.316.052-.588-.248-.588-.248s-.18.292-.396.368c-.216.072-.496-.108-.496-.108s-.048.108-.08.172c-.032.064-.124.076-.124.076l.072.188c.772-.224 1.824-.364 3.012-.364s2.268.14 3.044.368l.08-.216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m142.892 735.332-.236-.212s-.228.136-.512.096c-.28-.044-.372-.388-.372-.388s-.316.268-.576.248c-.26-.024-.428-.248-.428-.248s-.284.204-.532.184c-.248-.024-.484-.332-.484-.332s-.252.32-.5.344c-.248.02-.452-.216-.452-.216s-.112.236-.428.288c-.316.052-.588-.248-.588-.248s-.18.292-.396.368c-.216.072-.496-.108-.496-.108s-.048.108-.08.172c-.032.064-.124.076-.124.076l.072.188c.772-.224 1.824-.364 3.012-.364s2.268.14 3.044.368l.08-.216h-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m139.776 734.296.112.02a.38.38 0 0 0-.024.152c0 .232.2.42.448.42a.45.45 0 0 0 .424-.292c.004.004.044-.152.06-.152.012 0 .012.164.02.164.028.212.22.356.44.356a.431.431 0 0 0 .444-.424c0-.016 0-.032-.004-.048l.14-.14.076.176a.413.413 0 0 0 .384.588.428.428 0 0 0 .352-.18l.092-.116v.144c0 .136.056.264.196.284 0 0 .152.012.364-.152.208-.164.32-.3.32-.3l.012.168s-.204.336-.388.44c-.1.06-.256.124-.38.1-.128-.02-.22-.124-.268-.244a.62.62 0 0 1-.32.088c-.252 0-.48-.14-.568-.344a.624.624 0 0 1-.464.2.656.656 0 0 1-.504-.232.65.65 0 0 1-.968-.104.657.657 0 0 1-.536.276.628.628 0 0 1-.436-.172.654.654 0 0 1-.968.032c-.088.204-.316.344-.568.344a.605.605 0 0 1-.316-.088c-.048.12-.14.224-.272.244-.12.024-.276-.04-.376-.1-.188-.104-.408-.44-.408-.44l.028-.168s.116.136.324.3c.208.164.364.152.364.152.136-.02.196-.148.196-.284v-.144l.088.116c.076.108.204.18.352.18a.413.413 0 0 0 .384-.588l.076-.176.14.14c-.004.016-.004.032-.004.048 0 .236.196.424.444.424.22 0 .412-.144.444-.356.004 0 .004-.164.016-.164.02 0 .056.156.064.152a.442.442 0 0 0 .424.292.433.433 0 0 0 .444-.42c0-.056 0-.104-.02-.152l.116-.02"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m139.776 734.296.112.02a.38.38 0 0 0-.024.152c0 .232.2.42.448.42a.45.45 0 0 0 .424-.292c.004.004.044-.152.06-.152.012 0 .012.164.02.164.028.212.22.356.44.356a.431.431 0 0 0 .444-.424c0-.016 0-.032-.004-.048l.14-.14.076.176a.413.413 0 0 0 .384.588.428.428 0 0 0 .352-.18l.092-.116v.144c0 .136.056.264.196.284 0 0 .152.012.364-.152.208-.164.32-.3.32-.3l.012.168s-.204.336-.388.44c-.1.06-.256.124-.38.1-.128-.02-.22-.124-.268-.244a.62.62 0 0 1-.32.088c-.252 0-.48-.14-.568-.344a.624.624 0 0 1-.464.2.656.656 0 0 1-.504-.232.65.65 0 0 1-.968-.104.657.657 0 0 1-.536.276.628.628 0 0 1-.436-.172.654.654 0 0 1-.968.032c-.088.204-.316.344-.568.344a.605.605 0 0 1-.316-.088c-.048.12-.14.224-.272.244-.12.024-.276-.04-.376-.1-.188-.104-.408-.44-.408-.44l.028-.168s.116.136.324.3c.208.164.364.152.364.152.136-.02.196-.148.196-.284v-.144l.088.116c.076.108.204.18.352.18a.413.413 0 0 0 .384-.588l.076-.176.14.14c-.004.016-.004.032-.004.048 0 .236.196.424.444.424.22 0 .412-.144.444-.356.004 0 .004-.164.016-.164.02 0 .056.156.064.152a.442.442 0 0 0 .424.292.433.433 0 0 0 .444-.42c0-.056 0-.104-.02-.152l.116-.02h.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M139.768 735.392c-1.204.004-2.288.148-3.068.376-.052.016-.116-.024-.132-.068-.016-.052.02-.112.072-.128.78-.24 1.892-.392 3.128-.392 1.236 0 2.352.152 3.132.392.052.016.088.076.072.128-.016.044-.08.084-.132.068-.78-.228-1.868-.372-3.072-.376"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    strokeLinejoin: "round",
    d: "M139.768 735.392c-1.204.004-2.288.148-3.068.376-.052.016-.116-.024-.132-.068-.016-.052.02-.112.072-.128.78-.24 1.892-.392 3.128-.392 1.236 0 2.352.152 3.132.392.052.016.088.076.072.128-.016.044-.08.084-.132.068-.78-.228-1.868-.372-3.072-.376z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M138.6 735.82c0-.088.08-.164.176-.164.096 0 .176.076.176.164 0 .092-.08.164-.176.164-.096 0-.176-.072-.176-.164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M138.6 735.82c0-.088.08-.164.176-.164.096 0 .176.076.176.164 0 .092-.08.164-.176.164-.096 0-.176-.072-.176-.164z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M139.78 735.892h-.384c-.072 0-.132-.056-.132-.124s.056-.124.128-.124h.784c.076 0 .132.056.132.124s-.06.124-.132.124h-.396"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M139.78 735.892h-.384c-.072 0-.132-.056-.132-.124s.056-.124.128-.124h.784c.076 0 .132.056.132.124s-.06.124-.132.124h-.396"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    d: "m137.84 736.024-.276.044c-.072.008-.14-.036-.152-.104a.128.128 0 0 1 .108-.14l.28-.04.284-.044c.072-.008.136.036.148.1a.126.126 0 0 1-.108.14l-.284.044"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m137.84 736.024-.276.044c-.072.008-.14-.036-.152-.104a.128.128 0 0 1 .108-.14l.28-.04.284-.044c.072-.008.136.036.148.1a.126.126 0 0 1-.108.14l-.284.044"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "m136.72 736.22.124-.2.26.052-.152.224-.232-.076"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m136.72 736.22.124-.2.26.052-.152.224-.232-.076"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M140.588 735.82c0-.088.076-.164.176-.164a.17.17 0 0 1 .172.164.167.167 0 0 1-.172.164c-.1 0-.176-.072-.176-.164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M140.588 735.82c0-.088.076-.164.176-.164a.17.17 0 0 1 .172.164.167.167 0 0 1-.172.164c-.1 0-.176-.072-.176-.164z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    d: "m141.7 736.024.276.044c.072.008.14-.036.152-.104a.125.125 0 0 0-.108-.14l-.28-.04-.284-.044c-.072-.008-.14.036-.148.1a.12.12 0 0 0 .108.14l.284.044"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m141.7 736.024.276.044c.072.008.14-.036.152-.104a.125.125 0 0 0-.108-.14l-.28-.04-.284-.044c-.072-.008-.14.036-.148.1a.12.12 0 0 0 .108.14l.284.044"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "m142.796 736.232-.1-.212-.268.024.128.236.24-.048"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m142.796 736.232-.1-.212-.268.024.128.236.24-.048"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M139.764 736.964c-.972 0-1.852-.088-2.52-.26.668-.172 1.548-.276 2.52-.28.976 0 1.86.108 2.532.28-.672.172-1.556.26-2.532.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    strokeLinejoin: "round",
    d: "M139.764 736.964c-.972 0-1.852-.088-2.52-.26.668-.172 1.548-.276 2.52-.28.976 0 1.86.108 2.532.28-.672.172-1.556.26-2.532.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M142.836 734.852c.024-.072 0-.148-.052-.168-.056-.012-.12.036-.148.108-.024.076 0 .152.056.168.052.016.116-.032.144-.108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M142.836 734.852c.024-.072 0-.148-.052-.168-.056-.012-.12.036-.148.108-.024.076 0 .152.056.168.052.016.116-.032.144-.108z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M140.9 734.48c.008-.08-.032-.148-.088-.156-.056-.008-.112.052-.12.132-.008.076.028.148.084.152.056.008.112-.052.124-.128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M140.9 734.48c.008-.08-.032-.148-.088-.156-.056-.008-.112.052-.12.132-.008.076.028.148.084.152.056.008.112-.052.124-.128z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M138.648 734.48c-.012-.08.028-.148.084-.156.056-.008.112.052.12.132.012.076-.028.148-.084.152-.056.008-.112-.052-.12-.128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M138.648 734.48c-.012-.08.028-.148.084-.156.056-.008.112.052.12.132.012.076-.028.148-.084.152-.056.008-.112-.052-.12-.128z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M136.708 734.852c-.024-.072 0-.148.052-.168.056-.012.12.036.148.108.024.076 0 .152-.056.168-.052.016-.116-.032-.144-.108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M136.708 734.852c-.024-.072 0-.148.052-.168.056-.012.12.036.148.108.024.076 0 .152-.056.168-.052.016-.116-.032-.144-.108z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m139.764 733.36-.344.208.256.552.088.056.088-.056.256-.552-.344-.208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m139.764 733.36-.344.208.256.552.088.056.088-.056.256-.552-.344-.208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m139.012 734.196.16.228.536-.168.056-.072-.06-.08-.532-.156-.16.248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m139.012 734.196.16.228.536-.168.056-.072-.06-.08-.532-.156-.16.248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m140.52 734.196-.156.228-.536-.168-.056-.072.056-.08.536-.156.156.248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m140.52 734.196-.156.228-.536-.168-.056-.072.056-.08.536-.156.156.248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m137.532 733.604-.268.256.344.456.092.036.068-.072.12-.548-.356-.128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m137.532 733.604-.268.256.344.456.092.036.068-.072.12-.548-.356-.128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m136.968 734.516.204.192.488-.264.036-.084-.068-.068-.56-.048-.1.272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m136.968 734.516.204.192.488-.264.036-.084-.068-.068-.56-.048-.1.272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m138.444 734.22-.104.252-.56-.052-.072-.064.04-.088.488-.256.208.208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m138.444 734.22-.104.252-.56-.052-.072-.064.04-.088.488-.256.208.208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m136.428 734.588-.044.264-.56.06-.084-.048.016-.092.424-.348.248.164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m136.428 734.588-.044.264-.56.06-.084-.048.016-.092.424-.348.248.164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M137.508 734.36c0-.104.088-.188.196-.188.108 0 .196.084.196.188 0 .1-.088.184-.196.184-.108 0-.196-.084-.196-.184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M137.508 734.36c0-.104.088-.188.196-.188.108 0 .196.084.196.188 0 .1-.088.184-.196.184-.108 0-.196-.084-.196-.184z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m142.008 733.604.268.256-.344.456-.092.036-.068-.072-.12-.548.356-.128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m142.008 733.604.268.256-.344.456-.092.036-.068-.072-.12-.548.356-.128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m142.572 734.516-.204.192-.488-.264-.04-.084.076-.068.56-.048.096.272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m142.572 734.516-.204.192-.488-.264-.04-.084.076-.068.56-.048.096.272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m141.096 734.22.104.252.56-.052.072-.064-.04-.088-.488-.256-.208.208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m141.096 734.22.104.252.56-.052.072-.064-.04-.088-.488-.256-.208.208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m143.036 734.588.044.264.56.06.084-.048-.02-.092-.42-.348-.248.164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m143.036 734.588.044.264.56.06.084-.048-.02-.092-.42-.348-.248.164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M139.572 734.184c0-.104.088-.188.196-.188.108 0 .196.084.196.188 0 .1-.088.184-.196.184-.108 0-.196-.084-.196-.184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M139.572 734.184c0-.104.088-.188.196-.188.108 0 .196.084.196.188 0 .1-.088.184-.196.184-.108 0-.196-.084-.196-.184z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M141.644 734.36c0-.104.088-.188.196-.188.108 0 .196.084.196.188 0 .1-.088.184-.196.184-.108 0-.196-.084-.196-.184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M141.644 734.36c0-.104.088-.188.196-.188.108 0 .196.084.196.188 0 .1-.088.184-.196.184-.108 0-.196-.084-.196-.184z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M135.672 734.9c-.004.004-.152-.192-.26-.292-.08-.072-.272-.132-.272-.132 0-.032.112-.112.232-.112.072 0 .14.028.18.08l.016-.08s.096.02.14.128c.048.116.02.288.02.288s-.02.08-.056.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M135.672 734.9c-.004.004-.152-.192-.26-.292-.08-.072-.272-.132-.272-.132 0-.032.112-.112.232-.112.072 0 .14.028.18.08l.016-.08s.096.02.14.128c.048.116.02.288.02.288s-.02.08-.056.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M135.68 734.8c.048-.048.144-.036.212.024.072.06.096.152.048.2-.048.052-.144.04-.212-.024-.072-.06-.096-.152-.048-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M135.68 734.8c.048-.048.144-.036.212.024.072.06.096.152.048.2-.048.052-.144.04-.212-.024-.072-.06-.096-.152-.048-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M143.792 734.9c.004.004.152-.192.264-.292.076-.072.268-.132.268-.132 0-.032-.112-.112-.232-.112a.225.225 0 0 0-.18.08l-.016-.08s-.096.02-.144.128c-.044.116-.012.288-.012.288s.016.08.052.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M143.792 734.9c.004.004.152-.192.264-.292.076-.072.268-.132.268-.132 0-.032-.112-.112-.232-.112a.225.225 0 0 0-.18.08l-.016-.08s-.096.02-.144.128c-.044.116-.012.288-.012.288s.016.08.052.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M143.796 734.8c-.044-.048-.14-.036-.212.024-.072.06-.096.152-.048.2.048.052.144.04.216-.024.072-.06.092-.152.044-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M143.796 734.8c-.044-.048-.14-.036-.212.024-.072.06-.096.152-.048.2.048.052.144.04.216-.024.072-.06.092-.152.044-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M135.332 739.448h8.916v-2.336h-8.916v2.336z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M135.332 739.448h8.916v-2.336h-8.916v2.336z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M136.268 741.004a.364.364 0 0 1 .164-.028h6.676c.068 0 .128.012.184.032a.56.56 0 0 1-.396-.528c0-.244.18-.456.412-.532a.773.773 0 0 1-.196.032h-6.68a.564.564 0 0 1-.188-.024l.036.008c.24.072.376.284.376.516a.558.558 0 0 1-.388.524"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    strokeLinejoin: "round",
    d: "M136.268 741.004a.364.364 0 0 1 .164-.028h6.676c.068 0 .128.012.184.032a.56.56 0 0 1-.396-.528c0-.244.18-.456.412-.532a.773.773 0 0 1-.196.032h-6.68a.564.564 0 0 1-.188-.024l.036.008c.24.072.376.284.376.516a.558.558 0 0 1-.388.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M136.432 740.976h6.676c.228 0 .408.14.408.312 0 .176-.18.316-.408.316h-6.676c-.224 0-.408-.14-.408-.316 0-.172.184-.312.408-.312"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M136.432 740.976h6.676c.228 0 .408.14.408.312 0 .176-.18.316-.408.316h-6.676c-.224 0-.408-.14-.408-.316 0-.172.184-.312.408-.312z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M136.432 739.448h6.68c.228 0 .412.12.412.264 0 .148-.184.268-.412.268h-6.68c-.224 0-.408-.12-.408-.268 0-.144.184-.264.408-.264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M136.432 739.448h6.68c.228 0 .412.12.412.264 0 .148-.184.268-.412.268h-6.68c-.224 0-.408-.12-.408-.268 0-.144.184-.264.408-.264z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    d: "M146.012 778.772c-.616 0-1.164-.132-1.572-.348-.4-.204-.944-.328-1.544-.328-.604 0-1.16.128-1.564.332-.404.212-.96.344-1.568.344-.616 0-1.168-.144-1.572-.36-.4-.196-.932-.316-1.516-.316-.608 0-1.144.116-1.544.324-.408.216-.968.352-1.58.352v.964c.612 0 1.172-.14 1.58-.352.4-.208.936-.328 1.544-.328.58 0 1.116.124 1.516.32.404.212.956.36 1.572.36.608 0 1.164-.132 1.568-.344.404-.208.96-.336 1.564-.336.6 0 1.144.128 1.544.332.408.216.948.348 1.564.348l.008-.964"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M146.012 778.772c-.616 0-1.164-.132-1.572-.348-.4-.204-.944-.328-1.544-.328-.604 0-1.16.128-1.564.332-.404.212-.96.344-1.568.344-.616 0-1.168-.144-1.572-.36-.4-.196-.932-.316-1.516-.316-.608 0-1.144.116-1.544.324-.408.216-.968.352-1.58.352v.964c.612 0 1.172-.14 1.58-.352.4-.208.936-.328 1.544-.328.58 0 1.116.124 1.516.32.404.212.956.36 1.572.36.608 0 1.164-.132 1.568-.344.404-.208.96-.336 1.564-.336.6 0 1.144.128 1.544.332.408.216.948.348 1.564.348l.008-.964z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M146.012 779.736c-.616 0-1.164-.132-1.572-.348-.4-.204-.944-.332-1.544-.332-.604 0-1.16.128-1.564.336-.404.212-.96.344-1.568.344-.616 0-1.168-.148-1.572-.36-.4-.196-.932-.32-1.516-.32-.608 0-1.144.12-1.544.328-.408.212-.968.352-1.58.352v.964c.612 0 1.172-.14 1.58-.352.4-.208.936-.328 1.544-.328.58 0 1.116.124 1.516.32.404.216.956.36 1.572.36.608 0 1.164-.136 1.568-.344.404-.208.96-.336 1.564-.336.6 0 1.144.128 1.544.336.408.212.948.344 1.564.344l.008-.964"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M146.012 779.736c-.616 0-1.164-.132-1.572-.348-.4-.204-.944-.332-1.544-.332-.604 0-1.16.128-1.564.336-.404.212-.96.344-1.568.344-.616 0-1.168-.148-1.572-.36-.4-.196-.932-.32-1.516-.32-.608 0-1.144.12-1.544.328-.408.212-.968.352-1.58.352v.964c.612 0 1.172-.14 1.58-.352.4-.208.936-.328 1.544-.328.58 0 1.116.124 1.516.32.404.216.956.36 1.572.36.608 0 1.164-.136 1.568-.344.404-.208.96-.336 1.564-.336.6 0 1.144.128 1.544.336.408.212.948.344 1.564.344l.008-.964"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    d: "M146.012 780.7c-.616 0-1.164-.132-1.572-.344-.4-.208-.944-.336-1.544-.336-.604 0-1.16.128-1.564.336-.404.208-.96.344-1.568.344-.616 0-1.168-.144-1.572-.36-.4-.196-.932-.32-1.516-.32-.608 0-1.144.12-1.544.328-.408.212-.968.352-1.58.352v.96c.612 0 1.172-.136 1.58-.352.4-.204.936-.32 1.544-.32.58 0 1.116.12 1.516.316.404.216.956.356 1.572.356.608 0 1.164-.128 1.568-.34.404-.208.96-.332 1.564-.332.6 0 1.144.124 1.544.328.408.22.948.344 1.564.344l.008-.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M146.012 780.7c-.616 0-1.164-.132-1.572-.344-.4-.208-.944-.336-1.544-.336-.604 0-1.16.128-1.564.336-.404.208-.96.344-1.568.344-.616 0-1.168-.144-1.572-.36-.4-.196-.932-.32-1.516-.32-.608 0-1.144.12-1.544.328-.408.212-.968.352-1.58.352v.96c.612 0 1.172-.136 1.58-.352.4-.204.936-.32 1.544-.32.58 0 1.116.12 1.516.316.404.216.956.356 1.572.356.608 0 1.164-.128 1.568-.34.404-.208.96-.332 1.564-.332.6 0 1.144.124 1.544.328.408.22.948.344 1.564.344l.008-.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M146.004 782.628c-.616 0-1.156-.132-1.564-.348-.4-.204-.944-.328-1.544-.328-.604 0-1.16.124-1.564.332-.404.208-.96.344-1.568.344-.616 0-1.168-.148-1.572-.36-.4-.2-.932-.316-1.516-.316-.608 0-1.144.116-1.544.324-.408.212-.968.352-1.58.352v-.96c.612 0 1.172-.144 1.58-.36.4-.204.936-.32 1.544-.32.58 0 1.116.12 1.516.316.404.216.956.356 1.572.356.608 0 1.164-.128 1.568-.34.404-.208.96-.332 1.564-.332.6 0 1.144.124 1.544.328.408.22.956.344 1.572.344l-.008.968"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M146.004 782.628c-.616 0-1.156-.132-1.564-.348-.4-.204-.944-.328-1.544-.328-.604 0-1.16.124-1.564.332-.404.208-.96.344-1.568.344-.616 0-1.168-.148-1.572-.36-.4-.2-.932-.316-1.516-.316-.608 0-1.144.116-1.544.324-.408.212-.968.352-1.58.352v-.96c.612 0 1.172-.144 1.58-.36.4-.204.936-.32 1.544-.32.58 0 1.116.12 1.516.316.404.216.956.356 1.572.356.608 0 1.164-.128 1.568-.34.404-.208.96-.332 1.564-.332.6 0 1.144.124 1.544.328.408.22.956.344 1.572.344l-.008.968"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    d: "M146.004 783.592c-.616 0-1.156-.132-1.564-.344-.4-.208-.944-.336-1.544-.336-.604 0-1.16.128-1.564.336-.404.208-.96.344-1.568.344-.616 0-1.168-.148-1.572-.36-.4-.2-.932-.32-1.516-.32-.608 0-1.144.12-1.544.328-.408.212-.968.352-1.58.352v-.956c.612 0 1.172-.148 1.58-.36.4-.208.936-.324 1.544-.324.58 0 1.116.12 1.516.316.404.212.956.36 1.572.36.608 0 1.164-.136 1.568-.344.404-.208.96-.332 1.564-.332.6 0 1.144.124 1.544.328.408.216.952.348 1.572.348l-.008.964"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M146.004 783.592c-.616 0-1.156-.132-1.564-.344-.4-.208-.944-.336-1.544-.336-.604 0-1.16.128-1.564.336-.404.208-.96.344-1.568.344-.616 0-1.168-.148-1.572-.36-.4-.2-.932-.32-1.516-.32-.608 0-1.144.12-1.544.328-.408.212-.968.352-1.58.352v-.956c.612 0 1.172-.148 1.58-.36.4-.208.936-.324 1.544-.324.58 0 1.116.12 1.516.316.404.212.956.36 1.572.36.608 0 1.164-.136 1.568-.344.404-.208.96-.332 1.564-.332.6 0 1.144.124 1.544.328.408.216.952.348 1.572.348l-.008.964z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M136.268 774.812c.02.084.052.16.052.248 0 .584-.508 1.052-1.124 1.052h9.176c-.62 0-1.124-.468-1.124-1.052 0-.084.016-.164.036-.248a.507.507 0 0 1-.176.024h-6.676a.561.561 0 0 1-.164-.024"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    strokeLinejoin: "round",
    d: "M136.268 774.812c.02.084.052.16.052.248 0 .584-.508 1.052-1.124 1.052h9.176c-.62 0-1.124-.468-1.124-1.052 0-.084.016-.164.036-.248a.507.507 0 0 1-.176.024h-6.676a.561.561 0 0 1-.164-.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M136.432 774.208h6.676c.228 0 .408.14.408.312s-.18.316-.408.316h-6.676c-.224 0-.408-.144-.408-.316 0-.172.184-.312.408-.312"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M136.432 774.208h6.676c.228 0 .408.14.408.312s-.18.316-.408.316h-6.676c-.224 0-.408-.144-.408-.316 0-.172.184-.312.408-.312z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M135.208 778.444h9.148v-2.332h-9.148v2.332z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M135.208 778.444h9.148v-2.332h-9.148v2.332z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M134.492 765.948c-.904.52-1.52 1.056-1.42 1.324.048.244.336.428.748.7.648.452 1.04 1.256.732 1.628a2.303 2.303 0 0 0 .876-1.796c0-.748-.36-1.424-.936-1.856"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M134.492 765.948c-.904.52-1.52 1.056-1.42 1.324.048.244.336.428.748.7.648.452 1.04 1.256.732 1.628a2.303 2.303 0 0 0 .876-1.796c0-.748-.36-1.424-.936-1.856z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M136.52 773.828h6.5v-31.852h-6.5v31.852z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M141.152 742.02v31.784m.732-31.784v31.784M136.52 773.828h6.5v-31.852h-6.5v31.852z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M149.66 753.888c-1.416-.584-3.828-1.02-6.596-1.112-.956.008-2.016.1-3.116.28-3.888.652-6.852 2.204-6.616 3.468l.02.104s-1.456-3.284-1.48-3.408c-.26-1.404 3.024-3.128 7.34-3.848a22.018 22.018 0 0 1 3.824-.304c2.76 0 5.16.356 6.608.892l.016 3.928"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    strokeLinejoin: "round",
    d: "M149.66 753.888c-1.416-.584-3.828-1.02-6.596-1.112-.956.008-2.016.1-3.116.28-3.888.652-6.852 2.204-6.616 3.468l.02.104s-1.456-3.284-1.48-3.408c-.26-1.404 3.024-3.128 7.34-3.848a22.018 22.018 0 0 1 3.824-.304c2.76 0 5.16.356 6.608.892l.016 3.928"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M136.508 757.888c-1.804-.128-3.032-.612-3.176-1.364-.112-.6.5-1.268 1.588-1.872.484.056 1.032.12 1.6.12l-.012 3.116"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M136.508 757.888c-1.804-.128-3.032-.612-3.176-1.364-.112-.6.5-1.268 1.588-1.872.484.056 1.032.12 1.6.12l-.012 3.116"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M143.032 755.452c1.128.172 1.972.452 2.392.796l.04.068c.2.412-.788 1.288-2.444 2.268l.012-3.132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M143.032 755.452c1.128.172 1.972.452 2.392.796l.04.068c.2.412-.788 1.288-2.444 2.268l.012-3.132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M132.468 764.032c-.172-.512 1.588-1.544 4.072-2.456 1.136-.404 2.072-.828 3.236-1.34 3.452-1.528 6-3.28 5.688-3.916l-.036-.068c.184.152.472 3.296.472 3.296.312.584-2.02 2.312-5.2 3.832-1.016.488-3.164 1.28-4.176 1.636-1.816.628-3.616 1.816-3.452 2.256l-.604-3.236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    strokeLinejoin: "round",
    d: "M132.468 764.032c-.172-.512 1.588-1.544 4.072-2.456 1.136-.404 2.072-.828 3.236-1.34 3.452-1.528 6-3.28 5.688-3.916l-.036-.068c.184.152.472 3.296.472 3.296.312.584-2.02 2.312-5.2 3.832-1.016.488-3.164 1.28-4.176 1.636-1.816.628-3.616 1.816-3.452 2.256l-.604-3.236v-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M136.068 752.36c.796-.288 1.316-.632 1.064-1.256-.164-.4-.572-.476-1.188-.252l-1.084.396.976 2.412c.108-.048.216-.096.324-.136.112-.04.228-.072.34-.104l-.432-1.056v-.004zm-.472-1.164.276-.1c.228-.084.484.04.6.32.084.212.064.452-.2.62-.084.052-.184.092-.28.132l-.396-.972M138.612 750.188c-.116.032-.228.064-.344.088-.116.02-.236.036-.352.048l.564 2.512 1.752-.352c-.02-.048-.048-.104-.056-.152-.012-.056-.012-.112-.016-.164-.308.088-.644.184-1.044.264l-.504-2.244M142.124 752.352c.328-.912.728-1.784 1.124-2.668-.072.012-.144.024-.216.028a1.945 1.945 0 0 1-.216 0 22.642 22.642 0 0 1-.748 1.92c-.328-.604-.692-1.196-.972-1.804-.136.016-.276.036-.412.048-.136.008-.28.004-.416.008.504.824.992 1.644 1.456 2.492.064-.012.128-.024.2-.032.064-.004.132.004.2.008M145.788 750.42c.06-.124.124-.24.192-.356-.096-.088-.384-.22-.724-.252-.716-.072-1.124.244-1.172.676-.104.904 1.324.828 1.256 1.428-.028.256-.3.36-.592.332-.324-.032-.564-.212-.604-.476l-.088-.008a3.03 3.03 0 0 1-.192.46c.212.136.484.212.74.236.732.076 1.288-.216 1.34-.696.092-.86-1.348-.908-1.292-1.416.024-.212.188-.352.56-.316.268.028.432.172.504.38l.072.008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M199.44 734.668s-.296.312-.512.356c-.212.04-.484-.196-.484-.196s-.192.204-.432.256c-.236.056-.564-.264-.564-.264s-.228.32-.428.396c-.204.072-.452-.096-.452-.096s-.092.156-.26.244c-.072.036-.192-.02-.192-.02l-.24-.152-.272-.288-.248-.096s-.112-.364-.124-.428a17.36 17.36 0 0 0-.032-.228c-.052-.26.348-.56.92-.688.328-.076.616-.072.824-.008.228-.192.712-.328 1.28-.328.516 0 .968.108 1.216.28.244-.172.696-.28 1.212-.28.568 0 1.048.136 1.276.328.212-.064.496-.068.828.008.568.128.972.428.92.688l-.032.228a9.61 9.61 0 0 1-.128.428l-.248.096-.272.288-.232.152s-.12.056-.192.02c-.172-.084-.264-.244-.264-.244s-.248.168-.452.096c-.204-.076-.428-.396-.428-.396s-.328.32-.568.264c-.236-.052-.428-.256-.428-.256s-.272.236-.484.196c-.216-.044-.508-.356-.508-.356"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.108,
    d: "M199.44 734.668s-.296.312-.512.356c-.212.04-.484-.196-.484-.196s-.192.204-.432.256c-.236.056-.564-.264-.564-.264s-.228.32-.428.396c-.204.072-.452-.096-.452-.096s-.092.156-.26.244c-.072.036-.192-.02-.192-.02l-.24-.152-.272-.288-.248-.096s-.112-.364-.124-.428a17.36 17.36 0 0 0-.032-.228c-.052-.26.348-.56.92-.688.328-.076.616-.072.824-.008.228-.192.712-.328 1.28-.328.516 0 .968.108 1.216.28.244-.172.696-.28 1.212-.28.568 0 1.048.136 1.276.328.212-.064.496-.068.828.008.568.128.972.428.92.688l-.032.228a9.61 9.61 0 0 1-.128.428l-.248.096-.272.288-.232.152s-.12.056-.192.02c-.172-.084-.264-.244-.264-.244s-.248.168-.452.096c-.204-.076-.428-.396-.428-.396s-.328.32-.568.264c-.236-.052-.428-.256-.428-.256s-.272.236-.484.196c-.216-.044-.508-.356-.508-.356z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M198.88 732.98c0-.436.244-.784.548-.784.304 0 .552.348.552.784 0 .432-.248.784-.552.784-.304 0-.548-.352-.548-.784"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M198.88 732.98c0-.436.244-.784.548-.784.304 0 .552.348.552.784 0 .432-.248.784-.552.784-.304 0-.548-.352-.548-.784z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M199.188 732.98c0-.4.112-.724.252-.724s.252.324.252.724c0 .4-.112.72-.252.72s-.252-.32-.252-.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M199.188 732.98c0-.4.112-.724.252-.724s.252.324.252.724c0 .4-.112.72-.252.72s-.252-.32-.252-.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M196.6 736.2c-.084-.228-.236-.432-.236-.432.78-.228 1.864-.372 3.072-.376 1.204.004 2.296.148 3.076.376l-.208.364a2.75 2.75 0 0 0-.152.324c-.704-.216-1.608-.324-2.72-.328-1.116.004-2.188.14-2.744.344.008 0-.04-.128-.096-.272h.008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M196.6 736.2c-.084-.228-.236-.432-.236-.432.78-.228 1.864-.372 3.072-.376 1.204.004 2.296.148 3.076.376l-.208.364a2.75 2.75 0 0 0-.152.324c-.704-.216-1.608-.324-2.72-.328-1.116.004-2.188.14-2.744.344.008 0-.04-.128-.096-.272h.008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M199.436 737.192c.972-.004 2.044-.152 2.44-.252.264-.08.416-.196.388-.336-.012-.064-.068-.12-.148-.152-.58-.188-1.624-.32-2.68-.32s-2.108.132-2.688.32c-.076.032-.136.088-.148.152-.028.14.128.256.392.336.396.1 1.472.248 2.444.252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M199.436 737.192c.972-.004 2.044-.152 2.44-.252.264-.08.416-.196.388-.336-.012-.064-.068-.12-.148-.152-.58-.188-1.624-.32-2.68-.32s-2.108.132-2.688.32c-.076.032-.136.088-.148.152-.028.14.128.256.392.336.396.1 1.472.248 2.444.252z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M201.796 733.332c0-.096.08-.176.176-.176a.18.18 0 0 1 .184.176c0 .092-.08.168-.184.168a.173.173 0 0 1-.176-.168"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.084,
    d: "M201.796 733.332c0-.096.08-.176.176-.176a.18.18 0 0 1 .184.176c0 .092-.08.168-.184.168a.173.173 0 0 1-.176-.168zM201.692 732.732c0-.096.08-.172.18-.172.1 0 .18.076.18.172 0 .092-.08.168-.18.168-.1 0-.18-.076-.18-.168zm-.452-.376c0-.096.08-.172.18-.172.1 0 .18.076.18.172 0 .096-.08.172-.18.172-.1 0-.18-.076-.18-.172zm-.568-.18c0-.096.084-.176.184-.176.1 0 .18.08.18.176 0 .092-.08.168-.18.168-.1 0-.184-.076-.184-.168zm-.572.02c0-.096.08-.172.176-.172.104 0 .184.076.184.172 0 .096-.08.168-.184.168a.17.17 0 0 1-.176-.168z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    strokeLinecap: "round",
    d: "M203.584 734.496c.052-.132.084-.28.084-.432a1.14 1.14 0 0 0-1.128-1.152c-.2 0-.388.052-.552.148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M201.568 733.684c.06-.104.1-.228.1-.348 0-.46-.472-.832-1.056-.832-.248 0-.476.068-.656.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.084,
    d: "M203.74 733.972c0-.096.08-.172.18-.172.1 0 .18.076.18.172 0 .096-.08.172-.18.172-.1 0-.18-.076-.18-.172zm-.072-.632c0-.096.084-.168.184-.168.1 0 .18.072.18.168 0 .096-.08.172-.18.172-.1 0-.184-.076-.184-.172zm-.404-.48c0-.096.08-.172.18-.172s.18.076.18.172c0 .092-.08.168-.18.168s-.18-.076-.18-.168zm-.544-.26c0-.092.084-.168.184-.168.1 0 .18.076.18.168 0 .096-.08.176-.18.176-.1 0-.184-.08-.184-.176zm-.576.024c0-.096.08-.172.18-.172s.184.076.184.172c0 .092-.084.172-.184.172s-.18-.08-.18-.172z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m202.56 735.332-.236-.212s-.228.136-.512.096c-.28-.044-.372-.388-.372-.388s-.316.268-.576.248c-.26-.024-.428-.248-.428-.248s-.284.204-.532.184c-.248-.024-.488-.332-.488-.332s-.248.32-.496.344c-.248.02-.452-.216-.452-.216s-.116.236-.432.288c-.316.052-.588-.248-.588-.248s-.176.292-.392.368c-.216.072-.496-.108-.496-.108s-.048.108-.08.172c-.036.064-.124.076-.124.076l.068.188c.776-.224 1.828-.364 3.016-.364s2.268.14 3.04.368l.08-.216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m202.56 735.332-.236-.212s-.228.136-.512.096c-.28-.044-.372-.388-.372-.388s-.316.268-.576.248c-.26-.024-.428-.248-.428-.248s-.284.204-.532.184c-.248-.024-.488-.332-.488-.332s-.248.32-.496.344c-.248.02-.452-.216-.452-.216s-.116.236-.432.288c-.316.052-.588-.248-.588-.248s-.176.292-.392.368c-.216.072-.496-.108-.496-.108s-.048.108-.08.172c-.036.064-.124.076-.124.076l.068.188c.776-.224 1.828-.364 3.016-.364s2.268.14 3.04.368l.08-.216z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M196.692 733.332c0-.096.08-.176.18-.176.1 0 .18.08.18.176 0 .092-.08.168-.18.168-.1 0-.18-.076-.18-.168"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.084,
    d: "M196.692 733.332c0-.096.08-.176.18-.176.1 0 .18.08.18.176 0 .092-.08.168-.18.168-.1 0-.18-.076-.18-.168zM196.792 732.732c0-.096.08-.172.18-.172s.184.076.184.172c0 .092-.084.168-.184.168s-.18-.076-.18-.168zm.452-.376c0-.096.08-.172.18-.172.1 0 .184.076.184.172 0 .096-.084.172-.184.172-.1 0-.18-.076-.18-.172zm.564-.18c0-.096.084-.176.184-.176.1 0 .18.08.18.176 0 .092-.08.168-.18.168-.1 0-.184-.076-.184-.168zm.58.02c0-.096.08-.172.18-.172.1 0 .18.076.18.172 0 .096-.08.168-.18.168-.1 0-.18-.072-.18-.168z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    strokeLinecap: "round",
    d: "M195.264 734.496a1.14 1.14 0 0 1 1.044-1.584c.2 0 .384.052.548.148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M197.292 733.672a.692.692 0 0 1-.116-.336c0-.46.476-.832 1.056-.832.248 0 .48.068.66.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.084,
    d: "M194.744 733.972c0-.096.084-.172.184-.172.096 0 .18.076.18.172 0 .096-.084.172-.18.172-.1 0-.184-.076-.184-.172zm.068-.632c0-.096.084-.168.184-.168.1 0 .18.072.18.168 0 .096-.08.172-.18.172-.1 0-.184-.076-.184-.172zm.408-.48c0-.096.08-.172.184-.172.096 0 .18.076.18.172 0 .092-.084.168-.18.168-.104 0-.184-.076-.184-.168zm.544-.26c0-.092.08-.168.18-.168s.18.076.18.168c0 .096-.08.176-.18.176s-.18-.08-.18-.176zm.576.024c0-.096.08-.172.18-.172.1 0 .18.076.18.172 0 .092-.08.172-.18.172-.1 0-.18-.08-.18-.172z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m199.44 734.296.112.02a.466.466 0 0 0-.02.152c0 .232.2.42.448.42a.441.441 0 0 0 .42-.292c.008.004.044-.152.064-.152.016 0 .012.164.016.164.028.212.224.356.444.356a.434.434 0 0 0 .444-.424c0-.016 0-.032-.004-.048l.14-.14.076.176a.358.358 0 0 0-.044.184c0 .224.192.404.428.404a.428.428 0 0 0 .352-.18l.092-.116-.004.144c0 .136.06.264.196.284 0 0 .16.012.364-.152.212-.164.324-.3.324-.3l.012.168s-.204.336-.388.44c-.1.06-.256.124-.38.1-.132-.02-.22-.124-.272-.244a.605.605 0 0 1-.316.088c-.252 0-.48-.14-.568-.344a.654.654 0 0 1-.968-.032.651.651 0 0 1-.972-.104.644.644 0 0 1-.968.104.656.656 0 0 1-.504.232.624.624 0 0 1-.464-.2c-.088.204-.316.344-.568.344a.605.605 0 0 1-.316-.088c-.048.12-.14.224-.272.244-.12.024-.276-.04-.376-.1-.188-.104-.408-.44-.408-.44l.028-.168s.112.136.32.3c.208.164.368.152.368.152.136-.02.192-.148.192-.284v-.144l.092.116c.076.108.204.18.352.18.236 0 .428-.18.428-.404a.358.358 0 0 0-.044-.184l.076-.176.14.14c-.004.016-.004.032-.004.048 0 .236.2.424.44.424.224 0 .416-.144.444-.356.008 0 .004-.164.02-.164.02 0 .056.156.06.152.06.168.228.292.428.292a.433.433 0 0 0 .444-.42.466.466 0 0 0-.02-.152l.116-.02"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m199.44 734.296.112.02a.466.466 0 0 0-.02.152c0 .232.2.42.448.42a.441.441 0 0 0 .42-.292c.008.004.044-.152.064-.152.016 0 .012.164.016.164.028.212.224.356.444.356a.434.434 0 0 0 .444-.424c0-.016 0-.032-.004-.048l.14-.14.076.176a.358.358 0 0 0-.044.184c0 .224.192.404.428.404a.428.428 0 0 0 .352-.18l.092-.116-.004.144c0 .136.06.264.196.284 0 0 .16.012.364-.152.212-.164.324-.3.324-.3l.012.168s-.204.336-.388.44c-.1.06-.256.124-.38.1-.132-.02-.22-.124-.272-.244a.605.605 0 0 1-.316.088c-.252 0-.48-.14-.568-.344a.654.654 0 0 1-.968-.032.651.651 0 0 1-.972-.104.644.644 0 0 1-.968.104.656.656 0 0 1-.504.232.624.624 0 0 1-.464-.2c-.088.204-.316.344-.568.344a.605.605 0 0 1-.316-.088c-.048.12-.14.224-.272.244-.12.024-.276-.04-.376-.1-.188-.104-.408-.44-.408-.44l.028-.168s.112.136.32.3c.208.164.368.152.368.152.136-.02.192-.148.192-.284v-.144l.092.116c.076.108.204.18.352.18.236 0 .428-.18.428-.404a.358.358 0 0 0-.044-.184l.076-.176.14.14c-.004.016-.004.032-.004.048 0 .236.2.424.44.424.224 0 .416-.144.444-.356.008 0 .004-.164.02-.164.02 0 .056.156.06.152.06.168.228.292.428.292a.433.433 0 0 0 .444-.42.466.466 0 0 0-.02-.152l.116-.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M199.436 735.392c-1.208.004-2.288.148-3.068.376-.052.016-.116-.024-.132-.068-.016-.052.02-.112.072-.128.78-.24 1.892-.392 3.128-.392 1.232 0 2.348.152 3.132.392.052.016.088.076.072.128-.016.044-.084.084-.132.068-.78-.228-1.868-.372-3.072-.376"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M199.436 735.392c-1.208.004-2.288.148-3.068.376-.052.016-.116-.024-.132-.068-.016-.052.02-.112.072-.128.78-.24 1.892-.392 3.128-.392 1.232 0 2.348.152 3.132.392.052.016.088.076.072.128-.016.044-.084.084-.132.068-.78-.228-1.868-.372-3.072-.376z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M198.268 735.82c0-.088.08-.164.176-.164.096 0 .176.076.176.164 0 .092-.08.164-.176.164-.096 0-.176-.072-.176-.164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M198.268 735.82c0-.088.08-.164.176-.164.096 0 .176.076.176.164 0 .092-.08.164-.176.164-.096 0-.176-.072-.176-.164z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M199.452 735.892h-.392c-.072 0-.132-.056-.132-.124s.06-.124.132-.124h.784c.072 0 .128.056.128.124a.126.126 0 0 1-.128.124h-.392"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M199.452 735.892h-.392c-.072 0-.132-.056-.132-.124s.06-.124.132-.124h.784c.072 0 .128.056.128.124a.126.126 0 0 1-.128.124h-.392"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    d: "m197.508 736.024-.28.044c-.072.008-.136-.036-.148-.104-.012-.068.036-.128.108-.14l.276-.04.288-.044c.068-.008.136.036.148.1a.126.126 0 0 1-.112.14l-.28.044"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m197.508 736.024-.28.044c-.072.008-.136-.036-.148-.104-.012-.068.036-.128.108-.14l.276-.04.288-.044c.068-.008.136.036.148.1a.126.126 0 0 1-.112.14l-.28.044"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "m196.388 736.22.12-.2.264.052-.152.224-.232-.076"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m196.388 736.22.12-.2.264.052-.152.224-.232-.076"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M200.256 735.82a.17.17 0 0 1 .172-.164c.096 0 .176.076.176.164 0 .092-.08.164-.176.164a.167.167 0 0 1-.172-.164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M200.256 735.82a.17.17 0 0 1 .172-.164c.096 0 .176.076.176.164 0 .092-.08.164-.176.164a.167.167 0 0 1-.172-.164z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    d: "m201.364 736.024.28.044c.072.008.136-.036.148-.104.012-.068-.036-.128-.104-.14l-.28-.04-.284-.044c-.072-.008-.14.036-.152.1a.126.126 0 0 0 .112.14l.28.044"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m201.364 736.024.28.044c.072.008.136-.036.148-.104.012-.068-.036-.128-.104-.14l-.28-.04-.284-.044c-.072-.008-.14.036-.152.1a.126.126 0 0 0 .112.14l.28.044"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "m202.464 736.232-.1-.212-.272.024.132.236.24-.048"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m202.464 736.232-.1-.212-.272.024.132.236.24-.048"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M199.432 736.964c-.972 0-1.852-.088-2.524-.26.672-.172 1.552-.276 2.524-.28.976 0 1.86.108 2.528.28-.668.172-1.552.26-2.528.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    strokeLinejoin: "round",
    d: "M199.432 736.964c-.972 0-1.852-.088-2.524-.26.672-.172 1.552-.276 2.524-.28.976 0 1.86.108 2.528.28-.668.172-1.552.26-2.528.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M202.504 734.852c.024-.072 0-.148-.056-.168-.052-.012-.116.036-.14.108-.028.076-.004.152.048.168.056.016.12-.032.148-.108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M202.504 734.852c.024-.072 0-.148-.056-.168-.052-.012-.116.036-.14.108-.028.076-.004.152.048.168.056.016.12-.032.148-.108z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M200.564 734.48c.012-.08-.028-.148-.084-.156-.056-.008-.112.052-.12.132-.012.076.028.148.084.152.056.008.112-.052.12-.128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M200.564 734.48c.012-.08-.028-.148-.084-.156-.056-.008-.112.052-.12.132-.012.076.028.148.084.152.056.008.112-.052.12-.128z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M198.316 734.48c-.012-.08.024-.148.084-.156.056-.008.108.052.12.132.008.076-.028.148-.084.152-.056.008-.112-.052-.12-.128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M198.316 734.48c-.012-.08.024-.148.084-.156.056-.008.108.052.12.132.008.076-.028.148-.084.152-.056.008-.112-.052-.12-.128z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M196.376 734.852c-.028-.072 0-.148.052-.168.052-.012.12.036.144.108.028.076.004.152-.048.168-.056.016-.12-.032-.148-.108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M196.376 734.852c-.028-.072 0-.148.052-.168.052-.012.12.036.144.108.028.076.004.152-.048.168-.056.016-.12-.032-.148-.108z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m199.432 733.36-.34.208.252.552.088.056.088-.056.256-.552-.344-.208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m199.432 733.36-.34.208.252.552.088.056.088-.056.256-.552-.344-.208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m198.68 734.196.156.228.536-.168.056-.072-.056-.08-.536-.156-.156.248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m198.68 734.196.156.228.536-.168.056-.072-.056-.08-.536-.156-.156.248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m200.188 734.196-.156.228-.536-.168-.056-.072.056-.08.536-.156.156.248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m200.188 734.196-.156.228-.536-.168-.056-.072.056-.08.536-.156.156.248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m197.2 733.604-.268.256.344.456.092.036.068-.072.12-.548-.356-.128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m197.2 733.604-.268.256.344.456.092.036.068-.072.12-.548-.356-.128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m196.636 734.516.2.192.492-.264.036-.084-.072-.068-.556-.048-.1.272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m196.636 734.516.2.192.492-.264.036-.084-.072-.068-.556-.048-.1.272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m198.112 734.22-.104.252-.56-.052-.072-.064.036-.088.492-.256.208.208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m198.112 734.22-.104.252-.56-.052-.072-.064.036-.088.492-.256.208.208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m196.096 734.588-.044.264-.56.06-.088-.048.024-.092.42-.348.248.164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m196.096 734.588-.044.264-.56.06-.088-.048.024-.092.42-.348.248.164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M197.176 734.36c0-.104.088-.188.196-.188.108 0 .196.084.196.188 0 .1-.088.184-.196.184-.108 0-.196-.084-.196-.184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M197.176 734.36c0-.104.088-.188.196-.188.108 0 .196.084.196.188 0 .1-.088.184-.196.184-.108 0-.196-.084-.196-.184z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m201.676 733.604.268.256-.344.456-.092.036-.068-.072-.12-.548.356-.128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m201.676 733.604.268.256-.344.456-.092.036-.068-.072-.12-.548.356-.128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m202.24 734.516-.204.192-.488-.264-.04-.084.072-.068.56-.048.1.272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m202.24 734.516-.204.192-.488-.264-.04-.084.072-.068.56-.048.1.272"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m200.764 734.22.104.252.56-.052.072-.064-.04-.088-.488-.256-.208.208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m200.764 734.22.104.252.56-.052.072-.064-.04-.088-.488-.256-.208.208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m202.704 734.588.044.264.56.06.084-.048-.02-.092-.42-.348-.248.164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m202.704 734.588.044.264.56.06.084-.048-.02-.092-.42-.348-.248.164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M199.24 734.184c0-.104.088-.188.196-.188.108 0 .196.084.196.188 0 .1-.088.184-.196.184-.108 0-.196-.084-.196-.184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M199.24 734.184c0-.104.088-.188.196-.188.108 0 .196.084.196.188 0 .1-.088.184-.196.184-.108 0-.196-.084-.196-.184z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M201.308 734.36c0-.104.092-.188.2-.188.108 0 .196.084.196.188 0 .1-.088.184-.196.184-.108 0-.2-.084-.2-.184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M201.308 734.36c0-.104.092-.188.2-.188.108 0 .196.084.196.188 0 .1-.088.184-.196.184-.108 0-.2-.084-.2-.184z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M199.068 732.08c0-.192.164-.348.368-.348s.372.156.372.348a.362.362 0 0 1-.372.352.359.359 0 0 1-.368-.352"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M199.696 731.956v.232h-.568v-.232h.188v-.52h-.248v-.232h.248v-.232h.244v.232h.24v.232h-.24v.52h.136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.12,
    d: "M199.696 731.956v.232h-.568v-.232h.188v-.52h-.248v-.232h.248v-.232h.244v.232h.24v.232h-.24v.52h.136z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M199.952 731.956v.232h-1.012v-.232h.376v-.52h-.248v-.232h.248v-.232h.244v.232h.244v.232h-.244v.52h.392"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M199.544 731.748a.35.35 0 0 1 .264.332.36.36 0 0 1-.372.352.359.359 0 0 1-.368-.352c0-.16.116-.296.272-.336"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M195.34 734.9c-.004.004-.152-.192-.264-.292-.076-.072-.268-.132-.268-.132 0-.032.112-.112.232-.112.072 0 .14.028.18.08l.012-.08s.1.02.144.128c.044.116.016.288.016.288s-.02.08-.052.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M195.34 734.9c-.004.004-.152-.192-.264-.292-.076-.072-.268-.132-.268-.132 0-.032.112-.112.232-.112.072 0 .14.028.18.08l.012-.08s.1.02.144.128c.044.116.016.288.016.288s-.02.08-.052.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M195.348 734.8c.044-.048.14-.036.212.024.072.06.092.152.044.2-.044.052-.14.04-.212-.024-.072-.06-.092-.152-.044-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M195.348 734.8c.044-.048.14-.036.212.024.072.06.092.152.044.2-.044.052-.14.04-.212-.024-.072-.06-.092-.152-.044-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M203.46 734.9c.004.004.152-.192.26-.292.08-.072.272-.132.272-.132 0-.032-.112-.112-.236-.112a.222.222 0 0 0-.176.08l-.016-.08s-.1.02-.144.128c-.044.116-.016.288-.016.288s.02.08.056.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M203.46 734.9c.004.004.152-.192.26-.292.08-.072.272-.132.272-.132 0-.032-.112-.112-.236-.112a.222.222 0 0 0-.176.08l-.016-.08s-.1.02-.144.128c-.044.116-.016.288-.016.288s.02.08.056.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M203.464 734.8c-.048-.048-.144-.036-.216.024-.072.06-.092.152-.044.2.044.052.14.04.212-.024.072-.06.096-.152.048-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M203.464 734.8c-.048-.048-.144-.036-.216.024-.072.06-.092.152-.044.2.044.052.14.04.212-.024.072-.06.096-.152.048-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M194.984 739.448h8.916v-2.336h-8.916v2.336z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M194.984 739.448h8.916v-2.336h-8.916v2.336z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M202.964 741.004a.364.364 0 0 0-.164-.028h-6.676a.538.538 0 0 0-.184.032.562.562 0 0 0 .392-.528.577.577 0 0 0-.408-.532.744.744 0 0 0 .196.032h6.68a.564.564 0 0 0 .188-.024l-.04.008a.527.527 0 0 0-.372.516c0 .224.148.452.388.524"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    strokeLinejoin: "round",
    d: "M202.964 741.004a.364.364 0 0 0-.164-.028h-6.676a.538.538 0 0 0-.184.032.562.562 0 0 0 .392-.528.577.577 0 0 0-.408-.532.744.744 0 0 0 .196.032h6.68a.564.564 0 0 0 .188-.024l-.04.008a.527.527 0 0 0-.372.516c0 .224.148.452.388.524z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M196.124 740.976h6.676c.224 0 .408.14.408.312 0 .176-.184.316-.408.316h-6.676c-.228 0-.408-.14-.408-.316 0-.172.18-.312.408-.312"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M196.124 740.976h6.676c.224 0 .408.14.408.312 0 .176-.184.316-.408.316h-6.676c-.228 0-.408-.14-.408-.316 0-.172.18-.312.408-.312z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M196.12 739.448h6.68c.224 0 .408.12.408.264 0 .148-.184.268-.408.268h-6.68c-.228 0-.412-.12-.412-.268 0-.144.184-.264.412-.264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M196.12 739.448h6.68c.224 0 .408.12.408.264 0 .148-.184.268-.408.268h-6.68c-.228 0-.412-.12-.412-.268 0-.144.184-.264.412-.264z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    d: "M193.22 778.772c.616 0 1.164-.132 1.568-.348.404-.204.948-.328 1.548-.328.604 0 1.16.128 1.564.332.4.212.96.344 1.568.344.616 0 1.168-.144 1.572-.36.4-.196.932-.316 1.516-.316.608 0 1.14.116 1.544.324.404.216.968.352 1.58.352v.964c-.612 0-1.176-.14-1.58-.352-.404-.208-.936-.328-1.544-.328-.584 0-1.116.124-1.516.32-.404.212-.956.36-1.572.36-.608 0-1.164-.132-1.568-.344-.404-.208-.96-.336-1.564-.336-.6 0-1.144.128-1.548.332-.404.216-.944.348-1.56.348l-.008-.964"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M193.22 778.772c.616 0 1.164-.132 1.568-.348.404-.204.948-.328 1.548-.328.604 0 1.16.128 1.564.332.4.212.96.344 1.568.344.616 0 1.168-.144 1.572-.36.4-.196.932-.316 1.516-.316.608 0 1.14.116 1.544.324.404.216.968.352 1.58.352v.964c-.612 0-1.176-.14-1.58-.352-.404-.208-.936-.328-1.544-.328-.584 0-1.116.124-1.516.32-.404.212-.956.36-1.572.36-.608 0-1.164-.132-1.568-.344-.404-.208-.96-.336-1.564-.336-.6 0-1.144.128-1.548.332-.404.216-.944.348-1.56.348l-.008-.964z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M193.22 779.736c.616 0 1.164-.132 1.568-.348.404-.204.948-.332 1.548-.332.604 0 1.16.128 1.564.336.4.212.96.344 1.568.344.616 0 1.168-.148 1.572-.36.4-.196.932-.32 1.516-.32.608 0 1.14.12 1.544.328.404.212.968.352 1.58.352v.964c-.612 0-1.176-.14-1.58-.352-.404-.208-.936-.328-1.544-.328-.584 0-1.116.124-1.516.32-.404.216-.956.36-1.572.36-.608 0-1.164-.136-1.568-.344-.404-.208-.96-.336-1.564-.336-.6 0-1.144.128-1.548.336-.404.212-.944.344-1.56.344l-.008-.964"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M193.22 779.736c.616 0 1.164-.132 1.568-.348.404-.204.948-.332 1.548-.332.604 0 1.16.128 1.564.336.4.212.96.344 1.568.344.616 0 1.168-.148 1.572-.36.4-.196.932-.32 1.516-.32.608 0 1.14.12 1.544.328.404.212.968.352 1.58.352v.964c-.612 0-1.176-.14-1.58-.352-.404-.208-.936-.328-1.544-.328-.584 0-1.116.124-1.516.32-.404.216-.956.36-1.572.36-.608 0-1.164-.136-1.568-.344-.404-.208-.96-.336-1.564-.336-.6 0-1.144.128-1.548.336-.404.212-.944.344-1.56.344l-.008-.964"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    d: "M193.22 780.7c.616 0 1.164-.132 1.568-.344.404-.208.948-.336 1.548-.336.604 0 1.16.128 1.564.336.4.208.96.344 1.568.344.616 0 1.168-.144 1.572-.36.4-.196.932-.32 1.516-.32.608 0 1.14.12 1.544.328.404.212.968.352 1.58.352v.96c-.612 0-1.176-.136-1.58-.352-.404-.204-.936-.32-1.544-.32-.584 0-1.116.12-1.516.316-.404.216-.956.356-1.572.356-.608 0-1.164-.128-1.568-.34-.404-.208-.96-.332-1.564-.332-.6 0-1.144.124-1.548.328-.404.22-.944.344-1.56.344l-.008-.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M193.22 780.7c.616 0 1.164-.132 1.568-.344.404-.208.948-.336 1.548-.336.604 0 1.16.128 1.564.336.4.208.96.344 1.568.344.616 0 1.168-.144 1.572-.36.4-.196.932-.32 1.516-.32.608 0 1.14.12 1.544.328.404.212.968.352 1.58.352v.96c-.612 0-1.176-.136-1.58-.352-.404-.204-.936-.32-1.544-.32-.584 0-1.116.12-1.516.316-.404.216-.956.356-1.572.356-.608 0-1.164-.128-1.568-.34-.404-.208-.96-.332-1.564-.332-.6 0-1.144.124-1.548.328-.404.22-.944.344-1.56.344l-.008-.96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M193.228 782.628c.616 0 1.156-.132 1.56-.348.404-.204.948-.328 1.548-.328.604 0 1.16.124 1.564.332.4.208.96.344 1.568.344.616 0 1.168-.148 1.572-.36.4-.2.932-.316 1.516-.316.608 0 1.14.116 1.544.324.404.212.968.352 1.58.352v-.96c-.612 0-1.176-.144-1.58-.36-.404-.204-.936-.32-1.544-.32-.584 0-1.116.12-1.516.316-.404.216-.956.356-1.572.356-.608 0-1.164-.128-1.568-.34-.404-.208-.96-.332-1.564-.332-.6 0-1.144.124-1.548.328-.404.22-.952.344-1.568.344l.008.968"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M193.228 782.628c.616 0 1.156-.132 1.56-.348.404-.204.948-.328 1.548-.328.604 0 1.16.124 1.564.332.4.208.96.344 1.568.344.616 0 1.168-.148 1.572-.36.4-.2.932-.316 1.516-.316.608 0 1.14.116 1.544.324.404.212.968.352 1.58.352v-.96c-.612 0-1.176-.144-1.58-.36-.404-.204-.936-.32-1.544-.32-.584 0-1.116.12-1.516.316-.404.216-.956.356-1.572.356-.608 0-1.164-.128-1.568-.34-.404-.208-.96-.332-1.564-.332-.6 0-1.144.124-1.548.328-.404.22-.952.344-1.568.344l.008.968"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    d: "M193.228 783.592c.616 0 1.156-.132 1.56-.344.404-.208.948-.336 1.548-.336.604 0 1.16.128 1.564.336.4.208.96.344 1.568.344.616 0 1.168-.148 1.572-.36.4-.2.932-.32 1.516-.32.608 0 1.14.12 1.544.328.404.212.968.352 1.58.352v-.956c-.612 0-1.176-.148-1.58-.36-.404-.208-.936-.324-1.544-.324-.584 0-1.116.12-1.516.316-.404.212-.956.36-1.572.36-.608 0-1.164-.136-1.568-.344-.404-.208-.96-.332-1.564-.332-.6 0-1.144.124-1.548.328-.404.216-.952.348-1.568.348l.008.964"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M193.228 783.592c.616 0 1.156-.132 1.56-.344.404-.208.948-.336 1.548-.336.604 0 1.16.128 1.564.336.4.208.96.344 1.568.344.616 0 1.168-.148 1.572-.36.4-.2.932-.32 1.516-.32.608 0 1.14.12 1.544.328.404.212.968.352 1.58.352v-.956c-.612 0-1.176-.148-1.58-.36-.404-.208-.936-.324-1.544-.324-.584 0-1.116.12-1.516.316-.404.212-.956.36-1.572.36-.608 0-1.164-.136-1.568-.344-.404-.208-.96-.332-1.564-.332-.6 0-1.144.124-1.548.328-.404.216-.952.348-1.568.348l.008.964z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M202.964 774.812c-.024.084-.052.16-.052.248 0 .584.508 1.052 1.124 1.052h-9.176c.62 0 1.124-.468 1.124-1.052 0-.084-.016-.164-.036-.248.048.02.112.024.176.024h6.672c.056 0 .12-.008.164-.024"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    strokeLinejoin: "round",
    d: "M202.964 774.812c-.024.084-.052.16-.052.248 0 .584.508 1.052 1.124 1.052h-9.176c.62 0 1.124-.468 1.124-1.052 0-.084-.016-.164-.036-.248.048.02.112.024.176.024h6.672c.056 0 .12-.008.164-.024h.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M196.124 774.208h6.676c.224 0 .408.14.408.312s-.184.316-.408.316h-6.676c-.228 0-.408-.144-.408-.316 0-.172.18-.312.408-.312"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M196.124 774.208h6.676c.224 0 .408.14.408.312s-.184.316-.408.316h-6.676c-.228 0-.408-.144-.408-.316 0-.172.18-.312.408-.312z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M194.872 778.444h9.152v-2.332h-9.152v2.332z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M194.872 778.444h9.152v-2.332h-9.152v2.332z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M204.74 765.948c.904.52 1.52 1.056 1.42 1.324-.048.244-.336.428-.748.7-.648.452-1.04 1.256-.732 1.628a2.3 2.3 0 0 1 .06-3.652"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M204.74 765.948c.904.52 1.52 1.056 1.42 1.324-.048.244-.336.428-.748.7-.648.452-1.04 1.256-.732 1.628a2.3 2.3 0 0 1 .06-3.652z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M196.212 773.828h6.5v-31.852h-6.5v31.852z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M200.928 741.964v31.784m.732-31.784v31.784M196.212 773.828h6.5v-31.852h-6.5v31.852z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M189.568 753.888c1.42-.584 3.832-1.02 6.6-1.112.956.008 2.016.1 3.116.28 3.888.652 6.848 2.204 6.616 3.468-.008.024-.016.08-.02.104 0 0 1.456-3.284 1.48-3.408.26-1.404-3.024-3.128-7.34-3.848a22.048 22.048 0 0 0-3.824-.304c-2.764 0-5.164.356-6.608.892l-.02 3.928"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    strokeLinejoin: "round",
    d: "M189.568 753.888c1.42-.584 3.832-1.02 6.6-1.112.956.008 2.016.1 3.116.28 3.888.652 6.848 2.204 6.616 3.468-.008.024-.016.08-.02.104 0 0 1.456-3.284 1.48-3.408.26-1.404-3.024-3.128-7.34-3.848a22.048 22.048 0 0 0-3.824-.304c-2.764 0-5.164.356-6.608.892l-.02 3.928"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M202.724 757.888c1.804-.128 3.036-.612 3.176-1.364.112-.6-.5-1.268-1.588-1.872-.488.056-1.036.12-1.6.12l.012 3.116"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M202.724 757.888c1.804-.128 3.036-.612 3.176-1.364.112-.6-.5-1.268-1.588-1.872-.488.056-1.036.12-1.6.12l.012 3.116"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M196.2 755.452c-1.128.172-1.972.452-2.396.796l-.036.068c-.204.412.788 1.288 2.44 2.268l-.008-3.132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M196.2 755.452c-1.128.172-1.972.452-2.396.796l-.036.068c-.204.412.788 1.288 2.44 2.268l-.008-3.132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M206.76 764.032c.172-.512-1.584-1.544-4.068-2.456-1.136-.404-2.076-.828-3.236-1.34-3.452-1.528-6.004-3.28-5.688-3.916l.036-.068c-.184.152-.468 3.296-.468 3.296-.316.584 2.02 2.312 5.192 3.832 1.02.488 3.168 1.28 4.18 1.636 1.816.628 3.616 1.816 3.452 2.256l.6-3.236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    strokeLinejoin: "round",
    d: "M206.76 764.032c.172-.512-1.584-1.544-4.068-2.456-1.136-.404-2.076-.828-3.236-1.34-3.452-1.528-6.004-3.28-5.688-3.916l.036-.068c-.184.152-.468 3.296-.468 3.296-.316.584 2.02 2.312 5.192 3.832 1.02.488 3.168 1.28 4.18 1.636 1.816.628 3.616 1.816 3.452 2.256l.6-3.236v-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M193.62 752.492c.248-.932.564-1.832.876-2.748-.068.02-.14.036-.212.044-.068.012-.144.016-.216.02a21.942 21.942 0 0 1-.568 1.976c-.384-.576-.8-1.136-1.132-1.72-.136.028-.272.06-.408.08-.136.02-.276.028-.416.044a54.83 54.83 0 0 1 1.68 2.364c.064-.016.128-.04.2-.048.064-.008.132-.008.196-.012M196.092 749.764c-.116.004-.236.016-.352.012-.12 0-.24-.016-.356-.024l-.048 2.564 1.796.032a.773.773 0 0 1-.024-.164c0-.052.016-.108.028-.16-.324.02-.672.04-1.084.032l.04-2.292M198.908 750.184c.288.024.564.076.84.124-.004-.052-.012-.108-.008-.164.004-.052.024-.104.04-.156l-2.428-.2c.004.056.012.108.008.16-.004.056-.024.108-.04.16.248-.008.548-.008.884.02l-.212 2.308c.116 0 .236 0 .352.012.12.008.236.028.352.044l.212-2.308M199.904 752.712c.116.02.236.036.352.06.112.024.228.06.34.092l.288-1.176.032.004c.064.164.152.36.196.476l.36.888c.144.024.284.044.42.072.144.032.28.072.416.112l-.124-.268c-.192-.4-.396-.804-.564-1.208.448.016.792-.144.88-.504.06-.248-.04-.444-.272-.612-.176-.124-.512-.188-.732-.24l-.976-.212-.616 2.516m1.256-2.168c.284.064.636.108.636.428-.004.084-.012.14-.024.192-.092.376-.376.504-.852.364l.24-.984M204.528 753.484c-.02.276-.072.548-.124.84.12.056.244.108.36.176.12.064.228.136.344.208l.24-2.892a1.169 1.169 0 0 1-.312-.172l-2.552 1.62c.068.032.14.064.204.1.068.036.124.076.188.112.216-.18.44-.328.696-.52l.956.524v.004zm-.724-.664.852-.548-.1.96-.752-.412"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.02,
    d: "M159.58 726.68c0-.456.388-.824.868-.824.476 0 .864.368.864.824 0 .452-.388.82-.864.82-.48 0-.868-.368-.868-.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M169.36 719.588c2.656 0 5.024.396 6.564 1.004.88.4 2.064.692 3.36.868.988.132 1.924.156 2.74.096 1.092-.024 2.668.296 4.248.992 1.304.58 2.396 1.284 3.12 1.964l-.628.56-.18 1.584-1.72 1.968-.86.732-2.036 1.628-1.04.084-.316.9-13.164-1.544-13.208 1.544-.316-.9-1.044-.084-2.032-1.628-.86-.732-1.72-1.968-.176-1.584-.632-.56c.728-.68 1.816-1.384 3.12-1.964 1.58-.696 3.156-1.016 4.248-.992.816.06 1.752.036 2.74-.096 1.296-.176 2.48-.468 3.36-.868 1.544-.608 3.776-1.004 6.432-1.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M169.56 736.972c-4.904-.008-9.3-.588-12.436-1.532a.482.482 0 0 1-.336-.5.469.469 0 0 1 .336-.468c3.136-.944 7.532-1.524 12.436-1.532 4.908.008 9.3.588 12.436 1.532.22.068.336.26.332.468a.483.483 0 0 1-.332.5c-3.136.944-7.528 1.524-12.436 1.532"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M169.548 736.328c-4.424-.004-8.428-.516-11.472-1.304 3.044-.788 7.048-1.268 11.472-1.276 4.428.008 8.452.488 11.496 1.276-3.044.788-7.068 1.3-11.496 1.304"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.036,
    d: "M169.88 736.356v-2.628"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.056,
    d: "M169.164 736.356v-2.628"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.072,
    d: "M168.492 736.356v-2.628"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.092,
    d: "M167.824 736.356v-2.628"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.112,
    d: "M167.228 736.356v-2.628"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.132,
    d: "m166.092 736.212-.016-2.388m.556 2.42v-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.148,
    d: "M165.044 736.104v-2.2m.532 2.264-.016-2.344"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.168,
    d: "M163.64 735.98v-1.936m.46 1.968v-2.032m.476 2.096v-2.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.184,
    d: "M163.148 735.964v-1.872"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.204,
    d: "M162.688 735.868v-1.744"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.224,
    d: "M162.196 735.824V734.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.24,
    d: "m161.188 735.68-.016-1.288m.532 1.352v-1.448"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.252,
    d: "M160.672 735.572v-1.136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.272,
    d: "M160.196 735.48v-.944"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.292,
    d: "M159.68 735.352v-.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.308,
    d: "M159.148 735.292v-.552"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.364,
    d: "M158.588 735.164v-.268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.02,
    d: "M172.716 736.212v-2.404m-1.208 2.484.016-2.548m-.896 2.58v-2.596"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M169.528 732.936c-4.964.012-9.42.632-12.556 1.6.26-.124.236-.448-.088-1.28-.392-1.012-1-.968-1-.968 3.464-1.024 8.292-1.664 13.664-1.672 5.376.008 10.24.648 13.708 1.672 0 0-.612-.044-1.004.968-.324.832-.348 1.156-.084 1.28-3.136-.968-7.676-1.588-12.64-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M169.548 730.62c-5.372.008-10.2.648-13.664 1.672-.232.068-.476-.02-.552-.24a.424.424 0 0 1 .28-.54c3.484-1.068 8.432-1.74 13.936-1.752 5.508.012 10.476.684 13.96 1.752.232.068.356.32.28.54-.076.22-.32.308-.552.24-3.468-1.024-8.312-1.664-13.688-1.672"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    strokeLinejoin: "round",
    d: "M169.548 736.328c-4.424-.004-8.428-.516-11.472-1.304 3.044-.788 7.048-1.268 11.472-1.276 4.428.008 8.452.488 11.496 1.276-3.044.788-7.068 1.3-11.496 1.304z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M165.716 731.84c0-.232.196-.416.44-.416.24 0 .44.184.44.416 0 .228-.2.416-.44.416a.429.429 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M169.56 732.164h-1.316c-.24 0-.444-.184-.444-.412 0-.232.196-.416.44-.416h2.656c.244 0 .44.184.44.416 0 .228-.204.412-.444.412h-1.332"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "m162.956 732.528-.944.108c-.244.028-.468-.132-.496-.36-.032-.228.14-.436.384-.46l.948-.112.968-.112c.24-.028.46.132.488.36a.425.425 0 0 1-.384.464l-.964.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M159.112 732.612c0-.232.196-.416.44-.416s.44.184.44.416a.429.429 0 0 1-.44.416.429.429 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "m156.188 733.364.488-.636 1.348.172-1.076.784-.76-.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "m176.164 732.528.944.108c.24.028.468-.132.496-.36a.419.419 0 0 0-.384-.46l-.948-.112-.968-.112c-.244-.028-.46.132-.488.36-.032.228.144.436.384.464l.964.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M172.524 731.84c0-.232.2-.416.44-.416.244 0 .44.184.44.416a.429.429 0 0 1-.44.416c-.24 0-.44-.188-.44-.416M179.128 732.612c0-.232.196-.416.44-.416s.44.184.44.416a.429.429 0 0 1-.44.416.429.429 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "m182.928 733.364-.484-.636-1.348.172 1.076.784.756-.32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M157.548 735.164c3.1-.872 7.316-1.408 12-1.416 4.688.008 8.924.544 12.024 1.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m159.636 723.068.552.444.832-1.36c-.9-.552-1.52-1.512-1.52-2.604 0-.124.008-.244.024-.364.084-1.736 2.2-3.168 4.88-3.168 1.392 0 2.652.38 3.536.992.024-.268.048-.5.084-.744-.972-.568-2.24-.912-3.62-.912-3.084 0-5.496 1.756-5.612 3.828a3.78 3.78 0 0 0-.02.368c0 1.104.504 2.104 1.304 2.796l-.44.724"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "m159.636 723.068.552.444.832-1.36c-.9-.552-1.52-1.512-1.52-2.604 0-.124.008-.244.024-.364.084-1.736 2.2-3.168 4.88-3.168 1.392 0 2.652.38 3.536.992.024-.268.048-.5.084-.744-.972-.568-2.24-.912-3.62-.912-3.084 0-5.496 1.756-5.612 3.828a3.78 3.78 0 0 0-.02.368c0 1.104.504 2.104 1.304 2.796l-.44.724"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M159.672 723.084c-1.052-.788-1.708-1.856-1.708-3.032 0-1.352.888-2.56 2.232-3.364-.828.668-1.332 1.532-1.404 2.492a3.78 3.78 0 0 0-.02.368c0 1.104.504 2.104 1.304 2.796l-.404.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M159.672 723.084c-1.052-.788-1.708-1.856-1.708-3.032 0-1.352.888-2.56 2.232-3.364-.828.668-1.332 1.532-1.404 2.492a3.78 3.78 0 0 0-.02.368c0 1.104.504 2.104 1.304 2.796l-.404.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M150.384 724.456a3.658 3.658 0 0 1-.952-2.448c0-.564.132-1.1.364-1.58.852-1.752 3.528-3.028 6.704-3.028.864 0 1.692.092 2.456.268-.168.184-.3.388-.432.592a10.598 10.598 0 0 0-2.024-.192c-2.908 0-5.344 1.132-6.048 2.66a2.932 2.932 0 0 0-.292 1.28c0 .928.436 1.76 1.116 2.328l-1.052 1.72-.564-.448.724-1.152"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M150.384 724.456a3.658 3.658 0 0 1-.952-2.448c0-.564.132-1.1.364-1.58.852-1.752 3.528-3.028 6.704-3.028.864 0 1.692.092 2.456.268-.168.184-.3.388-.432.592a10.598 10.598 0 0 0-2.024-.192c-2.908 0-5.344 1.132-6.048 2.66a2.932 2.932 0 0 0-.292 1.28c0 .928.436 1.76 1.116 2.328l-1.052 1.72-.564-.448.724-1.152z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M151.46 718.692c-.764.484-1.344 1.076-1.664 1.736a3.623 3.623 0 0 0-.364 1.58c0 .932.36 1.788.952 2.448l-.64 1.036c-.612-.784-.968-1.704-.968-2.68 0-1.68 1.068-3.148 2.684-4.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M151.46 718.692c-.764.484-1.344 1.076-1.664 1.736a3.623 3.623 0 0 0-.364 1.58c0 .932.36 1.788.952 2.448l-.64 1.036c-.612-.784-.968-1.704-.968-2.68 0-1.68 1.068-3.148 2.684-4.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M169.516 715.008c.704 0 1.312.464 1.456 1.092.092.552.152 1.18.164 1.848.004.072-.004.14-.004.208 0 .08.016.164.02.244.024 1.408.224 2.648.508 3.408l-2.144 2.056-2.172-2.056c.288-.76.488-2 .516-3.408 0-.08.016-.164.016-.244 0-.068-.004-.136-.004-.208.012-.668.072-1.296.164-1.848.144-.628.776-1.092 1.48-1.092"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M169.516 715.008c.704 0 1.312.464 1.456 1.092.092.552.152 1.18.164 1.848.004.072-.004.14-.004.208 0 .08.016.164.02.244.024 1.408.224 2.648.508 3.408l-2.144 2.056-2.172-2.056c.288-.76.488-2 .516-3.408 0-.08.016-.164.016-.244 0-.068-.004-.136-.004-.208.012-.668.072-1.296.164-1.848.144-.628.776-1.092 1.48-1.092z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M169.516 715.676c.364 0 .672.232.748.556.092.524.148 1.12.16 1.752 0 .064-.004.128-.004.192 0 .08.012.156.016.236.02 1.328.212 2.5.484 3.22l-1.416 1.34-1.416-1.34c.268-.72.46-1.892.484-3.22 0-.08.016-.156.016-.236 0-.064-.004-.128-.004-.192.012-.632.068-1.228.16-1.752.072-.324.408-.556.772-.556"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M169.516 715.676c.364 0 .672.232.748.556.092.524.148 1.12.16 1.752 0 .064-.004.128-.004.192 0 .08.012.156.016.236.02 1.328.212 2.5.484 3.22l-1.416 1.34-1.416-1.34c.268-.72.46-1.892.484-3.22 0-.08.016-.156.016-.236 0-.064-.004-.128-.004-.192.012-.632.068-1.228.16-1.752.072-.324.408-.556.772-.556z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m179.38 723.068-.556.444-.832-1.36c.904-.552 1.524-1.512 1.524-2.604 0-.124-.008-.244-.024-.364-.084-1.736-2.2-3.168-4.88-3.168-1.396 0-2.652.38-3.536.992a10 10 0 0 0-.088-.744c.976-.568 2.24-.912 3.624-.912 3.084 0 5.496 1.756 5.612 3.828.012.124.02.244.02.368 0 1.104-.508 2.104-1.308 2.796l.444.724"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "m179.38 723.068-.556.444-.832-1.36c.904-.552 1.524-1.512 1.524-2.604 0-.124-.008-.244-.024-.364-.084-1.736-2.2-3.168-4.88-3.168-1.396 0-2.652.38-3.536.992a10 10 0 0 0-.088-.744c.976-.568 2.24-.912 3.624-.912 3.084 0 5.496 1.756 5.612 3.828.012.124.02.244.02.368 0 1.104-.508 2.104-1.308 2.796l.444.724"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M179.344 723.084c1.052-.788 1.708-1.856 1.708-3.032 0-1.352-.888-2.56-2.232-3.364.828.668 1.332 1.532 1.404 2.492.012.124.02.244.02.368 0 1.104-.508 2.104-1.308 2.796l.408.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M179.344 723.084c1.052-.788 1.708-1.856 1.708-3.032 0-1.352-.888-2.56-2.232-3.364.828.668 1.332 1.532 1.404 2.492.012.124.02.244.02.368 0 1.104-.508 2.104-1.308 2.796l.408.74"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M188.632 724.456c.588-.66.952-1.516.952-2.448 0-.564-.132-1.1-.364-1.58-.856-1.752-3.528-3.028-6.704-3.028-.864 0-1.692.092-2.46.268.172.184.304.388.436.592a10.567 10.567 0 0 1 2.024-.192c2.908 0 5.34 1.132 6.044 2.66.188.388.292.824.292 1.28 0 .928-.436 1.76-1.116 2.328l1.052 1.72.568-.448-.724-1.152"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M188.632 724.456c.588-.66.952-1.516.952-2.448 0-.564-.132-1.1-.364-1.58-.856-1.752-3.528-3.028-6.704-3.028-.864 0-1.692.092-2.46.268.172.184.304.388.436.592a10.567 10.567 0 0 1 2.024-.192c2.908 0 5.34 1.132 6.044 2.66.188.388.292.824.292 1.28 0 .928-.436 1.76-1.116 2.328l1.052 1.72.568-.448-.724-1.152z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M187.556 718.692c.764.484 1.344 1.076 1.664 1.736.232.48.364 1.016.364 1.58 0 .932-.364 1.788-.952 2.448l.64 1.036c.612-.784.964-1.704.964-2.68 0-1.68-1.068-3.148-2.68-4.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M187.556 718.692c.764.484 1.344 1.076 1.664 1.736.232.48.364 1.016.364 1.58 0 .932-.364 1.788-.952 2.448l.64 1.036c.612-.784.964-1.704.964-2.68 0-1.68-1.068-3.148-2.68-4.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M168.752 722.072c0-.396.34-.716.764-.716.42 0 .76.32.76.716 0 .4-.34.724-.76.724-.424 0-.764-.324-.764-.724"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M168.752 722.072c0-.396.34-.716.764-.716.42 0 .76.32.76.716 0 .4-.34.724-.76.724-.424 0-.764-.324-.764-.724z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M168.752 720.66c0-.396.34-.72.764-.72.42 0 .76.324.76.72 0 .4-.34.72-.76.72-.424 0-.764-.32-.764-.72M168.904 719.14c0-.32.276-.576.612-.576.332 0 .604.256.604.576 0 .32-.272.576-.604.576-.336 0-.612-.256-.612-.576M169.076 717.768c0-.228.196-.412.44-.412.24 0 .436.184.436.412 0 .232-.196.42-.436.42a.43.43 0 0 1-.44-.42M169.164 716.572c0-.184.156-.332.352-.332.192 0 .348.148.348.332s-.156.332-.348.332a.341.341 0 0 1-.352-.332"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "m169.58 726.412.492.088c-.076.2-.096.42-.096.652 0 1.028.884 1.86 1.968 1.86.872 0 1.616-.54 1.868-1.284.032.02.188-.672.272-.664.068.008.06.72.088.708.124.936.984 1.572 1.948 1.572 1.084 0 1.964-.832 1.964-1.86 0-.076-.004-.152-.016-.228l.616-.608.332.776c-.132.244-.184.52-.184.812 0 .984.84 1.776 1.876 1.776a1.9 1.9 0 0 0 1.56-.788l.396-.5-.004.612c0 .62.264 1.172.864 1.272 0 0 .692.04 1.612-.68.916-.72 1.42-1.316 1.42-1.316l.08.72s-.76 1.18-1.588 1.66c-.456.264-1.144.54-1.692.452-.576-.096-.992-.56-1.204-1.096-.412.244-.9.388-1.42.388-1.124 0-2.132-.616-2.528-1.544-.516.56-1.236.9-2.08.9-.896 0-1.716-.404-2.228-1.024a2.88 2.88 0 0 1-1.952.748c-.992 0-1.876-.488-2.376-1.22-.5.732-1.384 1.22-2.376 1.22a2.87 2.87 0 0 1-1.948-.748c-.512.62-1.336 1.024-2.232 1.024-.844 0-1.56-.34-2.076-.9-.4.928-1.408 1.544-2.528 1.544a2.775 2.775 0 0 1-1.42-.388c-.216.536-.628 1-1.208 1.096-.544.088-1.232-.188-1.688-.452-.832-.48-1.592-1.66-1.592-1.66l.08-.72s.508.596 1.424 1.316c.916.724 1.608.68 1.608.68.604-.1.864-.652.864-1.272l-.004-.612.396.5c.336.476.912.788 1.56.788 1.036 0 1.876-.792 1.876-1.776 0-.292-.052-.568-.184-.812l.332-.776.616.608c-.008.076-.016.152-.016.228 0 1.028.88 1.86 1.964 1.86.968 0 1.824-.636 1.952-1.572.024.012.02-.7.088-.708.08-.008.24.684.268.664.256.744.996 1.284 1.872 1.284 1.084 0 1.964-.832 1.964-1.86 0-.232-.012-.452-.096-.652l.516-.088"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M183.084 728.864c.112-.332.012-.66-.228-.732-.24-.076-.528.132-.644.464-.112.332-.012.66.228.736.24.072.528-.136.644-.468M174.532 727.208c.044-.348-.12-.652-.372-.68-.252-.028-.492.228-.536.576-.044.344.124.652.372.68.252.028.492-.228.536-.576M164.604 727.208c-.044-.348.124-.652.372-.68.252-.028.492.228.536.576.044.344-.12.652-.372.68-.248.028-.488-.228-.536-.576M156.056 728.864c-.112-.332-.012-.66.228-.732.24-.076.528.132.64.464.112.332.012.66-.228.736-.24.072-.524-.136-.64-.468"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M159.772 723.16c.424.268.792.716.92 1.212 0 0 .052-.1.284-.236.236-.132.436-.128.436-.128s-.068.388-.1.528c-.036.136-.036.552-.128.928-.092.372-.252.672-.252.672a.793.793 0 0 0-.632-.164.748.748 0 0 0-.528.36s-.264-.232-.484-.552c-.22-.324-.372-.712-.452-.832-.084-.12-.288-.46-.288-.46s.188-.072.456-.02c.268.048.352.128.352.128a2.03 2.03 0 0 1 .416-1.436"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M159.948 727.244a.736.736 0 0 1-.268-.432.697.697 0 0 1 .092-.492s-.352-.176-.732-.276c-.288-.076-.796-.08-.948-.08-.152-.008-.46-.012-.46-.012a2.489 2.489 0 0 0 .312.52c-.508.116-.94.448-1.212.836.396.272.92.44 1.44.388 0 0-.048.136-.08.344-.024.172-.024.244-.024.244l.428-.156c.14-.052.616-.22.86-.384.32-.216.592-.5.592-.5M161.088 727.052a.691.691 0 0 0-.168-.92s.268-.284.588-.504c.24-.164.72-.328.86-.38.144-.052.428-.16.428-.16s0 .072-.024.244c-.032.208-.08.348-.08.348.52-.056 1.048.116 1.444.392a2.102 2.102 0 0 1-1.216.832s.092.112.2.296c.084.156.112.224.112.224l-.46-.012c-.152 0-.66-.004-.948-.08-.38-.1-.736-.276-.736-.276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M159.58 726.68c0-.456.388-.824.868-.824.476 0 .864.368.864.824 0 .452-.388.82-.864.82-.48 0-.868-.368-.868-.82"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M169.544 721.844c.42.38.74.944.78 1.528 0 0 .076-.108.364-.212.292-.104.512-.064.512-.064s-.156.42-.22.568c-.068.148-.156.612-.336 1.012-.176.4-.42.704-.42.704a.896.896 0 0 0-1.336 0s-.244-.304-.42-.704c-.18-.4-.268-.864-.336-1.012s-.224-.568-.224-.568.224-.04.512.064c.288.104.368.212.368.212.04-.584.344-1.148.756-1.528"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M168.9 726.432a.801.801 0 0 1-.212-.532c0-.2.076-.388.204-.528 0 0-.356-.268-.756-.448-.308-.14-.872-.236-1.04-.268l-.512-.096s.016.08.08.268c.08.224.16.372.16.372-.588.032-1.14.324-1.524.704.384.376.936.664 1.524.7 0 0-.08.144-.16.372-.064.184-.08.268-.08.268l.512-.096c.168-.032.732-.128 1.04-.268.4-.184.764-.444.764-.444M170.204 726.432a.782.782 0 0 0 .008-1.06s.356-.268.76-.448c.304-.14.868-.236 1.04-.268l.504-.096s-.008.08-.076.268c-.08.224-.16.372-.16.372.588.032 1.144.324 1.524.704-.38.376-.932.664-1.524.7a2.642 2.642 0 0 0 .236.64l-.504-.096c-.172-.032-.736-.128-1.04-.268-.404-.184-.768-.444-.768-.444M179.368 723.16c-.424.268-.792.716-.924 1.212 0 0-.048-.1-.284-.236-.232-.132-.436-.128-.436-.128s.068.388.104.528c.036.136.036.552.124.928.092.372.256.672.256.672a.788.788 0 0 1 .628-.164c.236.04.424.176.532.36 0 0 .264-.232.484-.552.216-.324.368-.712.448-.832.084-.12.288-.46.288-.46s-.188-.072-.456-.02c-.268.048-.352.128-.352.128a2.028 2.028 0 0 0-.412-1.436"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M179.188 727.244a.699.699 0 0 0 .268-.432.676.676 0 0 0-.088-.492s.352-.176.732-.276c.288-.076.796-.08.944-.08.156-.008.46-.012.46-.012s-.024.068-.112.22c-.104.184-.196.3-.196.3.504.116.936.448 1.212.836-.396.272-.924.44-1.44.388 0 0 .044.136.076.344.024.172.024.244.024.244l-.424-.156c-.144-.052-.62-.22-.864-.384-.316-.216-.592-.5-.592-.5M178.052 727.052a.718.718 0 0 1-.1-.492.714.714 0 0 1 .268-.428s-.268-.284-.588-.504c-.244-.164-.72-.328-.864-.38l-.424-.16s-.004.072.024.244c.032.208.076.348.076.348-.516-.056-1.044.116-1.44.392.272.388.708.716 1.212.832 0 0-.092.112-.196.296-.088.156-.112.224-.112.224l.456-.012c.152 0 .664-.004.948-.08.38-.1.736-.276.736-.276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M177.824 726.68c0-.456.388-.824.868-.824s.868.368.868.824c0 .452-.388.82-.868.82s-.868-.368-.868-.82M187.52 728.504c-.204-.216-.628-.172-.944.1-.316.268-.408.664-.204.876.204.216.628.168.944-.1.316-.272.408-.664.204-.876"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M186.288 729.028a.926.926 0 0 1 .288-.424c.316-.272.74-.316.944-.1a.421.421 0 0 1 .072.1s.44-.832.96-1.112c.52-.28 1.4-.208 1.4-.208 0-.64-.524-1.156-1.2-1.156-.396 0-.768.164-.988.444l-.092-.428s-.544.108-.792.728.02 1.52.02 1.52-.132-.384-.336-.644c-.204-.256-.724-.536-.996-.664-.272-.124-.548-.316-.548-.316s-.012.072-.024.244c-.008.204.008.332.008.332a3.25 3.25 0 0 0-1.532.192c.192.38.56.736 1.044.92 0 0-.172.144-.332.3-.132.136-.172.196-.172.196s.34.052.508.076c.172.02.736.112 1.072.088a6.17 6.17 0 0 0 .696-.088M152.848 729.028a.896.896 0 0 0-.288-.424c-.316-.272-.736-.316-.944-.1a.403.403 0 0 0-.068.1s-.444-.832-.964-1.112c-.516-.28-1.396-.208-1.396-.208 0-.64.52-1.156 1.196-1.156.396 0 .768.164.992.444l.092-.428s.544.108.792.728-.024 1.52-.024 1.52.136-.384.34-.644c.204-.256.724-.536.996-.664.268-.124.548-.316.548-.316s.012.072.02.244c.012.204-.004.332-.004.332a3.262 3.262 0 0 1 1.532.192c-.196.38-.564.736-1.048.92 0 0 .176.144.332.3.136.136.176.196.176.196s-.34.052-.508.076c-.172.02-.736.112-1.076.088a6.294 6.294 0 0 1-.696-.088"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M151.616 728.504c.208-.216.628-.172.944.1.32.268.408.664.204.876-.204.216-.628.168-.944-.1-.316-.272-.408-.664-.204-.876M168.688 725.9c0-.452.388-.82.868-.82.476 0 .868.368.868.82 0 .456-.388.824-.868.824s-.868-.368-.868-.824"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M167.748 713.42c0-.928.796-1.68 1.772-1.68.98 0 1.772.752 1.772 1.68 0 .928-.792 1.676-1.772 1.676-.976 0-1.772-.748-1.772-1.676"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M169.056 708.716v.904h-.968v.92h.968v2.644h-1.22c-.012.084-.088.148-.088.236 0 .232.048.456.14.656 0 .008.008.008.012.012h3.248c0-.004.008-.004.012-.012.088-.2.14-.424.14-.656 0-.088-.076-.152-.088-.236h-1.184v-2.644h.968v-.92h-.968v-.904h-.972z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M169.696 784.232c-5.232 0-10.42-1.28-14.78-3.416-3.212-1.592-5.344-4.8-5.344-8.476v-13.32h40.168v13.32c0 3.676-2.128 6.884-5.344 8.476-4.36 2.136-9.464 3.416-14.7 3.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.208,
    d: "M169.696 784.232c-5.232 0-10.42-1.28-14.78-3.416-3.212-1.592-5.344-4.8-5.344-8.476v-13.32h40.168v13.32c0 3.676-2.128 6.884-5.344 8.476-4.36 2.136-9.464 3.416-14.7 3.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M169.612 759h20.128v-22.288h-20.128V759z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.208,
    d: "M169.612 759h20.128v-22.288h-20.128V759z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M169.628 772.328c0 5.264-4.464 9.528-10.02 9.528-5.556 0-10.06-4.264-10.06-9.528v-13.34h20.08v13.34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    stroke: "#000",
    strokeWidth: 0.208,
    d: "M153.932 780.192c.628.332 1.488.888 2.412 1.108l-.06-22.784h-2.352v21.676z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    stroke: "#000",
    strokeWidth: 0.2,
    strokeLinejoin: "round",
    d: "M149.512 772.148c.06 2.808 1.18 4.9 2.292 6.268v-19.788h-2.264l-.028 13.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C7B500",
    stroke: "#000",
    strokeWidth: 0.208,
    d: "M158.412 781.8c.92.092 1.604.076 2.348 0v-23.284h-2.348V781.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    stroke: "#000",
    strokeWidth: 0.208,
    d: "M162.828 781.3c.92-.184 1.96-.756 2.412-1.052v-21.732h-2.352l-.06 22.784z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M149.548 759h20.072v-22.288h-20.072V759z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.208,
    d: "M149.548 759h20.072v-22.288h-20.072V759z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    stroke: "#000",
    strokeWidth: 0.208,
    d: "M167.424 778.196c.98-.872 1.9-2.848 2.236-5.104l.056-14.576h-2.348l.056 19.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.208,
    d: "M169.628 772.328c0 5.264-4.464 9.528-10.02 9.528-5.556 0-10.06-4.264-10.06-9.528v-13.34h20.08v13.34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M189.76 758.988v13.34c0 5.264-4.512 9.528-10.068 9.528-5.56 0-10.064-4.264-10.064-9.528v-13.34h20.132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.208,
    d: "M189.76 758.988v13.34c0 5.264-4.512 9.528-10.068 9.528-5.56 0-10.064-4.264-10.064-9.528v-13.34h20.132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M173.288 769.056a.485.485 0 0 1 .052.208c0 .244-.208.44-.468.44s-.468-.196-.468-.44c0-.072.016-.14.048-.2l-.652-.008a1.043 1.043 0 0 0 .74 1.196v1.604l.684.004.004-1.616c.316-.104.568-.344.676-.648h1.84v-.54h-2.456m9.032 0v.54l-1.656.008a.95.95 0 0 1-.104.2l1.92 2.184-.516.42-1.912-2.188c-.036.012-.052.024-.088.036l-.008 3.612h-.676l-.004-3.628a.265.265 0 0 1-.076-.036l-1.992 2.204-.516-.42 1.988-2.208a.852.852 0 0 1-.08-.184h-1.712v-.54h5.436-.004zm1.104 0v.54h1.844c.108.304.356.544.676.648v1.616l.684-.004v-1.604c.444-.132.764-.524.764-.988a.897.897 0 0 0-.024-.208h-.652a.48.48 0 0 1 .048.208c0 .244-.208.44-.464.44-.26 0-.468-.196-.468-.44 0-.072.016-.14.048-.2l-2.456-.008m-2.784 9.216a6.357 6.357 0 0 0 1.524-.44l.336.572a7.332 7.332 0 0 1-1.8.512c-.108.468-.544.816-1.068.816s-.96-.344-1.068-.808a7.231 7.231 0 0 1-1.892-.52l.336-.572c.516.22 1.064.364 1.632.444.124-.264.344-.464.632-.56l.004-2.8h.68l.004 2.792c.3.088.552.296.68.564zm-4.596-.94-.336.576a7.01 7.01 0 0 1-1.516-1.288 1.13 1.13 0 0 1-1.04-.2.99.99 0 0 1-.12-1.456l.056-.064a6.37 6.37 0 0 1-.528-2l.684.004c.056.6.204 1.172.436 1.708.196-.024.4-.004.584.064l1.712-1.892.516.416-1.7 1.892c.228.348.22.8-.044 1.14.376.42.812.792 1.296 1.1zm-2.536-1.984a.484.484 0 0 1 .66-.052c.196.16.22.44.052.624a.484.484 0 0 1-.66.052.427.427 0 0 1-.052-.624zm-.864-1.876-.704-.156-.1-1.78.7-.232v1.024c0 .396.036.768.104 1.144zm.584-2.208.7.164s.036 1.148.02.888c-.016-.296.076.896.076.896l-.704.232a5.707 5.707 0 0 1-.096-1.116l.004-1.064zm2.308 5.7c.592.46 1.276.832 2.016 1.072l.156-.68a5.727 5.727 0 0 1-1.668-.836l-.504.444m-.34.584c.6.452 1.284.812 2.016 1.064l-.52.488a7.715 7.715 0 0 1-1.648-.844l.152-.708m.916-3.924.668.284 1.224-1.36-.4-.576-1.492 1.652m-.52-.42-.4-.58 1.224-1.36.668.288-1.492 1.652m7.536 4.128.332.576a6.938 6.938 0 0 0 1.52-1.288c.348.104.74.044 1.036-.2a.997.997 0 0 0 .124-1.456l-.06-.064c.28-.624.468-1.296.528-2l-.68.004a5.598 5.598 0 0 1-.44 1.708 1.27 1.27 0 0 0-.584.064l-1.708-1.892-.516.416 1.7 1.892a.98.98 0 0 0 .04 1.14 6.21 6.21 0 0 1-1.292 1.1zm2.536-1.984a.484.484 0 0 0-.66-.052.427.427 0 0 0-.052.624.484.484 0 0 0 .66.052c.196-.16.22-.44.052-.624zm.86-1.876.704-.156.1-1.78-.696-.232-.004 1.024c0 .396-.032.768-.104 1.144zm-.58-2.208-.7.164s-.04 1.148-.024.888c.02-.296-.076.896-.076.896l.708.232c.068-.36.092-.736.092-1.116v-1.064m-2.312 5.7a6.592 6.592 0 0 1-2.016 1.072l-.156-.68a5.678 5.678 0 0 0 1.668-.836l.504.444m.34.584c-.6.452-1.28.812-2.016 1.064l.524.488a7.81 7.81 0 0 0 1.648-.844l-.156-.708m-.912-3.924-.672.284-1.224-1.36.404-.576 1.492 1.652m.516-.42.404-.58-1.224-1.36-.668.288 1.488 1.652M175.2 769.6l.204.668h1.888l.2-.668H175.2m8.808 0-.208.668h-1.884l-.204-.668h2.296m-4.844 9.1c0-.248.208-.448.468-.448.256 0 .468.2.468.448 0 .244-.212.44-.468.44-.26 0-.468-.196-.468-.44zm.792-3.232.704-.196v-1.784l-.704-.192v2.172m-.68 0-.704-.196v-1.784l.704-.192v2.172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M171.8 769.072c.08-.372.372-.676.744-.788l-.004-2.2h.68v2.212c.336.108.592.352.696.672l1.828.004v.1h-2.456a.48.48 0 0 0-.416-.236c-.184 0-.34.1-.42.244l-.652-.008m5.084 0v-.1h1.7a.735.735 0 0 1 .076-.16l-2.1-2.34.516-.416 2.072 2.3a.556.556 0 0 1 .112-.048v-3.064h.676v3.044c.032.012.076.02.108.028l2.024-2.304.52.412-2.032 2.292c.052.08.088.164.116.256h1.648v.1h-5.436zm8.996 0a.483.483 0 0 1 .42-.236c.18 0 .34.1.416.244l.652-.008a1.068 1.068 0 0 0-.744-.788l.004-2.2h-.676l-.004 2.216a1.033 1.033 0 0 0-.692.668l-1.832.004v.1h2.456m-12.552-6.216 2.524 2.828.516-.42-2.536-2.816c.048-.076.084-.156.116-.248h1.844v-.644h-1.844c-.144-.416-.556-.712-1.044-.712-.604 0-1.092.464-1.092 1.036 0 .452.304.84.736.98l-.004 2.18h.676v-2.168c.028-.008.08-.008.108-.016zm13.308.012-.008 2.172h-.676v-2.18a1 1 0 0 1-.152-.06l-2.508 2.828-.52-.412 2.556-2.884c-.02-.04-.044-.084-.056-.132h-1.856v-.644h1.848a1.085 1.085 0 0 1 1.04-.712c.6 0 1.092.464 1.092 1.036 0 .464-.316.856-.76.988zm-6.692-.008-.004 1.336h-.68l.004-1.324c-.34-.1-.604-.348-.716-.672h-1.652v-.644h1.652a1.084 1.084 0 0 1 1.036-.712c.488 0 .9.296 1.04.712h1.688v.644h-1.692a1.049 1.049 0 0 1-.676.66zm-7.396 1.624-.704.2v1.784l.704.196v-2.18m.684 0 .7.2v1.784l-.7.196v-2.18m12.712 0-.7.2v1.784l.7.196v-2.18m.684 0 .704.2v1.784l-.704.196v-2.18m-10.644.352.668-.284 1.224 1.36-.4.58-1.492-1.656m-.52.424-.4.58 1.224 1.36.668-.288-1.492-1.652m7.688-.476-.672-.28-1.212 1.372.408.576 1.476-1.668m.52.416.408.58-1.212 1.368-.672-.28 1.476-1.668m-8.472 3.772.204-.668h1.888l.2.668H175.2m-2.764-7.092c0-.244.208-.444.468-.444.256 0 .468.2.468.444s-.212.444-.468.444c-.26 0-.468-.2-.468-.444zm5.04.324-.204.668h-1.884l-.204-.668h2.292m0-.648-.204-.668h-1.884l-.204.668h2.292m6.532 7.416-.208-.668h-1.884l-.204.668h2.296m1.828-7.092c0-.244.208-.444.468-.444.256 0 .464.2.464.444s-.208.444-.464.444c-.26 0-.468-.2-.468-.444zm-6.72 0c0-.244.212-.444.468-.444.26 0 .468.2.468.444s-.208.444-.468.444a.459.459 0 0 1-.468-.444zm2.612.324.208.668h1.884l.204-.668h-2.296m0-.648.208-.668h1.884l.204.668h-2.296m-2.46 2.088-.704.196v1.788l.704.192v-2.176m.676 0 .7.196v1.788l-.7.192v-2.176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C8B100",
    strokeWidth: 0.104,
    d: "M180.64 778.272a6.357 6.357 0 0 0 1.524-.44l.336.572a7.332 7.332 0 0 1-1.8.512c-.108.468-.544.816-1.068.816s-.96-.344-1.068-.808a7.231 7.231 0 0 1-1.892-.52l.336-.572c.516.22 1.064.364 1.632.444.124-.264.344-.464.632-.56l.004-2.8h.68l.004 2.792c.3.088.552.296.68.564zm-1.96-8.492a.86.86 0 0 1-.084-.184h-1.712v-.64h1.7c.02-.056.048-.108.076-.16l-2.1-2.332.516-.42 2.072 2.296c.036-.016.072-.032.112-.048v-3.056h.676v3.04c.032.008.076.016.108.028l2.024-2.3.52.412-2.032 2.288c.052.076.088.16.116.252h1.648v.64l-1.656.008c-.024.072-.068.136-.104.2l1.92 2.188-.516.416-1.912-2.188c-.036.012-.052.028-.092.036l-.004 3.616h-.68v-3.632a.353.353 0 0 1-.08-.036l-1.992 2.204-.516-.416 1.992-2.212m-5.352-6.928 2.524 2.82.516-.416-2.536-2.812c.048-.076.084-.156.116-.244h1.844v-.644h-1.844c-.144-.416-.556-.712-1.044-.712-.604 0-1.092.46-1.092 1.032 0 .452.304.84.736.98l-.004 2.176h.676v-2.164c.028-.008.08-.008.108-.016zm2.716 14.48-.336.576a7.01 7.01 0 0 1-1.516-1.288 1.13 1.13 0 0 1-1.04-.2.99.99 0 0 1-.12-1.456l.056-.064a6.37 6.37 0 0 1-.528-2l.684.004c.056.6.204 1.172.436 1.708.196-.024.4-.004.584.064l1.712-1.892.516.416-1.7 1.892c.228.348.22.8-.044 1.14.376.42.812.792 1.296 1.1zm-3.504-5.476v-1.604c-.44-.132-.764-.524-.764-.988 0-.46.328-.86.768-.992l-.004-2.196h.68v2.208c.336.104.592.352.696.668l1.828.004v.64h-1.84c-.108.304-.36.544-.676.648l-.004 1.616-.684-.004m.968 3.492a.484.484 0 0 1 .66-.052c.196.16.22.44.052.624a.484.484 0 0 1-.66.052.427.427 0 0 1-.052-.624zm-.864-1.876-.704-.156-.1-1.78.7-.232v1.024c0 .396.036.768.104 1.144zm.584-2.208.7.164s.036 1.148.02.888c-.016-.296.076.896.076.896l-.704.232a5.707 5.707 0 0 1-.096-1.116l.004-1.064zm2.308 5.7c.592.46 1.276.832 2.016 1.072l.156-.68a5.727 5.727 0 0 1-1.668-.836l-.504.444m-.34.584c.6.452 1.284.812 2.016 1.064l-.52.488a7.715 7.715 0 0 1-1.648-.844l.152-.708"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C8B100",
    strokeWidth: 0.104,
    d: "m176.112 773.624.668.284 1.224-1.36-.4-.576-1.492 1.652m-.52-.42-.4-.58 1.224-1.36.668.288-1.492 1.652m-3.188-3.94c0-.244.208-.444.468-.444.256 0 .464.2.464.444s-.208.44-.464.44c-.26 0-.468-.196-.468-.44zm10.724 8.068.332.576a6.938 6.938 0 0 0 1.52-1.288c.348.104.74.044 1.036-.2a.997.997 0 0 0 .124-1.456l-.06-.064c.28-.624.468-1.296.528-2l-.68.004a5.598 5.598 0 0 1-.44 1.708 1.27 1.27 0 0 0-.584.064l-1.708-1.892-.516.416 1.7 1.892a.98.98 0 0 0 .04 1.14 6.21 6.21 0 0 1-1.292 1.1zm3.504-5.476-.004-1.604c.444-.132.764-.524.764-.988 0-.46-.324-.86-.768-.992l.004-2.196h-.676l-.004 2.208a1.042 1.042 0 0 0-.692.668l-1.832.004v.64h1.844c.108.304.356.544.676.648v1.616l.684-.004h.004zm-.968 3.492a.484.484 0 0 0-.66-.052.427.427 0 0 0-.052.624.484.484 0 0 0 .66.052c.196-.16.22-.44.052-.624zm.86-1.876.704-.156.1-1.78-.696-.232-.004 1.024c0 .396-.032.768-.104 1.144zm-.58-2.208-.7.164s-.04 1.148-.024.888c.02-.296-.076.896-.076.896l.708.232c.068-.36.092-.736.092-1.116v-1.064m.692-8.4-.008 2.168h-.676v-2.176a1 1 0 0 1-.152-.06l-2.508 2.824-.52-.412 2.556-2.88c-.02-.04-.044-.084-.056-.128h-1.856v-.644h1.848a1.085 1.085 0 0 1 1.04-.712c.6 0 1.092.46 1.092 1.032 0 .464-.316.856-.76.988zm-6.692-.008-.004 1.336h-.68l.004-1.324a1.07 1.07 0 0 1-.716-.668h-1.652v-.644h1.652a1.084 1.084 0 0 1 1.036-.712c.488 0 .9.296 1.04.712h1.688v.644h-1.692a1.052 1.052 0 0 1-.676.656zm3.688 14.108a6.592 6.592 0 0 1-2.016 1.072l-.156-.68a5.678 5.678 0 0 0 1.668-.836l.504.444m.34.584c-.6.452-1.28.812-2.016 1.064l.524.488a7.81 7.81 0 0 0 1.648-.844l-.156-.708m-11.424-13.072-.704.2v1.784l.704.192v-2.176m.684 0 .7.2v1.784l-.7.192v-2.176m12.712 0-.7.2v1.784l.7.192v-2.176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C8B100",
    strokeWidth: 0.104,
    d: "m186.628 764.476.704.2v1.784l-.704.192v-2.176m-3.568 9.148-.672.284-1.224-1.36.404-.576 1.492 1.652m.516-.42.404-.58-1.224-1.36-.668.288 1.488 1.652m-7.592-8.376.668-.284 1.224 1.36-.4.58-1.492-1.656m-.52.42-.4.584 1.224 1.356.668-.288-1.492-1.652m7.688-.472-.672-.276-1.212 1.368.408.572 1.476-1.664m.52.416.408.576-1.212 1.368-.672-.28 1.476-1.664m-8.472 3.764.204-.668h1.888l.2.668H175.2m0 .644.204.668h1.888l.2-.668H175.2m-2.764-7.724c0-.24.208-.44.468-.44.256 0 .468.2.468.44a.456.456 0 0 1-.468.444.454.454 0 0 1-.468-.444zm5.04.324-.204.668h-1.884l-.204-.668h2.292m0-.644-.204-.668h-1.884l-.204.668h2.292m8.356 7.708c0-.244.208-.444.468-.444.256 0 .464.2.464.444s-.208.44-.464.44c-.26 0-.468-.196-.468-.44zm-1.824-.308-.208-.668h-1.884l-.204.668h2.296m0 .644-.208.668h-1.884l-.204-.668h2.296m-4.844 9.1c0-.248.208-.448.468-.448.256 0 .468.2.468.448 0 .244-.212.44-.468.44-.26 0-.468-.196-.468-.44zm.792-3.232.704-.196v-1.784l-.704-.192v2.172m-.68 0-.704-.196v-1.784l.704-.192v2.172m6.56-13.592c0-.24.208-.44.468-.44.256 0 .464.2.464.44a.453.453 0 0 1-.464.444.454.454 0 0 1-.468-.444zm-6.72 0c0-.24.212-.44.468-.44.26 0 .468.2.468.44a.454.454 0 0 1-.468.444.456.456 0 0 1-.468-.444zm2.612.324.208.668h1.884l.204-.668h-2.296m0-.644.208-.668h1.884l.204.668h-2.296M179.268 763.636l-.704.2v1.784l.704.192v-2.176m.676 0 .7.2v1.784l-.7.192v-2.176"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    d: "M178.536 769.276c0-.576.492-1.04 1.096-1.04.604 0 1.092.464 1.092 1.04 0 .572-.488 1.032-1.092 1.032-.604 0-1.096-.46-1.096-1.032"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "m179.872 742.204.02-.248.036-.136s-.644.052-.984-.044a2.466 2.466 0 0 1-.96-.5c-.316-.272-.44-.44-.668-.472-.544-.088-.96.16-.96.16s.408.148.712.524.636.564.78.612c.236.072 1.064.02 1.288.028.228.012.736.076.736.076"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "m179.872 742.204.02-.248.036-.136s-.644.052-.984-.044a2.466 2.466 0 0 1-.96-.5c-.316-.272-.44-.44-.668-.472-.544-.088-.96.16-.96.16s.408.148.712.524.636.564.78.612c.236.072 1.064.02 1.288.028.228.012.736.076.736.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED72AA",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M182.884 741.3s.004.288.032.56c.024.268-.088.496-.044.644.044.148.064.264.12.372.056.104.084.376.084.376l-.296-.216c-.14-.108-.24-.176-.24-.176l.04.412c.016.124.088.356.204.496.116.132.348.356.42.532.072.18.056.576.056.576s-.184-.3-.348-.356c-.156-.056-.504-.248-.504-.248s.316.316.316.62c0 .3-.128.64-.128.64s-.144-.272-.332-.448c-.188-.18-.452-.36-.452-.36s.208.468.208.78c0 .316-.06.988-.06.988s-.156-.256-.316-.384c-.16-.124-.348-.232-.408-.312-.056-.084.192.256.216.464.028.204.128.94.768 1.876.376.548.956 1.508 2.2 1.192 1.244-.312.784-1.988.52-2.768-.26-.78-.392-1.644-.376-1.948.016-.3.232-1.188.204-1.356-.028-.164-.096-.8.056-1.312.16-.532.292-.74.38-.96.084-.22.156-.344.184-.536.028-.192.028-.548.028-.548s.232.424.292.576c.056.152.056.6.056.6s.044-.448.392-.668c.348-.22.752-.452.852-.576.1-.124.132-.204.132-.204s-.032.768-.248 1.068c-.144.196-.708.836-.708.836s.292-.112.492-.12c.204-.016.348 0 .348 0s-.248.192-.564.656c-.32.464-.188.504-.42.888-.232.384-.42.4-.712.632-.432.348-.2 1.736-.144 1.944.06.204.812 1.904.828 2.316.012.412.084 1.332-.64 1.92-.464.38-1.228.384-1.404.492-.172.112-.516.452-.516 1.164 0 .716.256.824.46 1.004.204.176.464.08.52.22.06.136.088.216.176.3.084.08.144.176.116.328-.032.152-.364.492-.48.74-.116.244-.348.892-.348.988 0 .096-.028.396.072.548 0 0 .364.424.116.504-.16.056-.312-.1-.388-.08-.216.056-.332.188-.392.18-.144-.028-.144-.1-.16-.304-.012-.204-.004-.288-.068-.288-.088 0-.132.072-.148.18-.016.108-.016.356-.116.356s-.244-.18-.332-.22c-.088-.04-.332-.08-.348-.192-.012-.108.144-.34.304-.384.16-.04.304-.12.204-.204-.104-.08-.204-.08-.304 0-.1.084-.316.016-.304-.108.016-.124.044-.276.028-.344-.012-.068-.188-.204.04-.328.236-.124.336.108.568.068.232-.04.344-.124.432-.26.088-.136.072-.424-.088-.6-.156-.18-.316-.208-.376-.32-.056-.108-.144-.368-.144-.368s.044.48.016.548c-.028.068-.016.356-.016.356s-.156-.18-.288-.316c-.128-.136-.26-.548-.26-.548s-.012.384-.012.536c0 .148.172.288.116.344-.06.052-.332-.288-.408-.344-.072-.056-.304-.232-.404-.424-.1-.192-.176-.464-.204-.564-.028-.096-.076-.524-.028-.632.072-.16.188-.452.188-.452h-.564c-.304 0-.52-.092-.636.112-.116.204-.06.616.084 1.152.148.532.232.792.192.888-.044.096-.232.316-.304.356-.076.044-.276.028-.364-.012a1.057 1.057 0 0 0-.504-.108c-.276 0-.448.012-.548-.012-.104-.028-.352-.152-.468-.124-.116.028-.316.128-.26.288.088.244-.084.3-.204.288-.116-.016-.212-.056-.36-.096-.144-.044-.36 0-.332-.168.028-.164.088-.176.16-.296.072-.128.1-.208.016-.216-.1-.008-.204-.02-.28.044-.08.064-.204.204-.304.152-.104-.056-.184-.172-.184-.432 0-.256-.272-.48-.02-.468.248.012.564.192.62.052.056-.14.024-.204-.112-.312-.136-.108-.304-.172-.124-.308.18-.14.224-.14.296-.216.068-.072.164-.316.292-.256.248.12.008.292.26.568.248.276.404.376.824.332.416-.044.532-.096.532-.216 0-.116-.036-.328-.048-.416-.008-.084.06-.396.06-.396s-.192.12-.252.236c-.052.116-.168.32-.168.32s-.044-.24-.032-.436c.008-.116.048-.316.044-.356-.012-.108-.092-.376-.092-.376s-.064.292-.112.376c-.044.084-.064.428-.064.428s-.268-.232-.192-.62c.052-.3-.048-.696.044-.824.088-.132.3-.656.824-.676.52-.02.924.02 1.108.012.18-.012.824-.132.824-.132s-1.188-.608-1.456-.792c-.272-.18-.692-.652-.828-.864-.136-.216-.26-.632-.26-.632s-.212.008-.408.116a2.054 2.054 0 0 0-.496.396c-.112.128-.292.42-.292.42s.032-.376.032-.492c0-.116-.024-.344-.024-.344s-.132.512-.404.704c-.272.196-.588.46-.588.46s.032-.284.032-.352c0-.064.068-.396.068-.396s-.192.288-.484.344c-.296.052-.724.044-.76.224-.032.18.08.428.012.556-.068.128-.216.216-.216.216s-.168-.14-.316-.152c-.144-.012-.284.064-.284.064s-.124-.16-.076-.268c.044-.104.268-.264.216-.332-.06-.064-.24.024-.352.076-.112.056-.352.108-.328-.076.02-.18.08-.288.02-.416-.056-.128-.02-.212.072-.244.088-.032.448.008.484-.076.032-.084-.088-.192-.328-.244-.236-.056-.352-.196-.228-.312.128-.12.16-.152.216-.256.056-.108.08-.304.296-.204.212.096.168.332.396.404.224.076.756-.032.868-.096.112-.064.476-.332.6-.396.124-.06.644-.448.644-.448s-.304-.212-.42-.32c-.112-.108-.312-.364-.416-.42-.1-.052-.6-.244-.768-.256-.168-.008-.688-.192-.688-.192s.236-.076.316-.14c.076-.064.256-.224.348-.212.088.008.112.008.112.008s-.484-.02-.588-.052c-.1-.032-.396-.216-.508-.216-.112 0-.336.044-.336.044s.304-.192.552-.236c.248-.04.44-.032.44-.032s-.384-.108-.476-.232c-.088-.132-.18-.32-.248-.408-.068-.084-.112-.224-.236-.236-.124-.012-.34.152-.464.14-.124-.012-.216-.088-.228-.268-.008-.184 0-.12-.04-.216-.048-.096-.228-.32-.06-.372.172-.056.532.032.568-.032.032-.064-.192-.26-.34-.332-.148-.076-.384-.204-.26-.312.124-.104.248-.148.316-.244s.148-.364.296-.28c.144.084.348.504.464.472.112-.032.12-.332.1-.46-.024-.128 0-.352.112-.332.112.02.204.172.384.184.18.008.452-.044.428.084-.02.128-.124.284-.248.424-.12.144-.18.42-.1.6.08.184.284.476.464.592.18.116.52.204.736.34.212.14.712.536.88.58.168.044.34.128.34.128s.192-.084.452-.084.856.04 1.084-.056c.228-.096.52-.256.432-.46-.092-.204-.588-.384-.544-.544.044-.16.228-.172.532-.184.304-.008.72.056.8-.376.08-.424.104-.672-.324-.768-.432-.096-.748-.108-.828-.416-.08-.312-.156-.388-.068-.472.092-.084.248-.128.564-.148.32-.024.68-.024.784-.1.1-.072.12-.276.244-.364.124-.084.612-.16.612-.16s.584.284 1.12.684c.484.36.92.892.92.892"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.72 740.996s-.068-.192-.08-.248a.54.54 0 0 0-.048-.116s.352 0 .34.108c-.008.108-.112.108-.136.148a.603.603 0 0 1-.076.108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M178.72 740.996s-.068-.192-.08-.248a.54.54 0 0 0-.048-.116s.352 0 .34.108c-.008.108-.112.108-.136.148a.603.603 0 0 1-.076.108z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.324 740.44-.024-.172s.308 0 .452.104c.228.16.372.408.364.42-.04.036-.216-.108-.34-.148 0 0-.092.02-.18.02-.092 0-.136-.044-.148-.084-.012-.048.012-.12.012-.12l-.136-.02"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.02,
    d: "m180.324 740.44-.024-.172s.308 0 .452.104c.228.16.372.408.364.42-.04.036-.216-.108-.34-.148 0 0-.092.02-.18.02-.092 0-.136-.044-.148-.084-.012-.048.012-.12.012-.12l-.136-.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M182.528 742.86s-.136-.192-.168-.26c-.036-.06-.092-.192-.092-.192"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M174.252 740.932s.192.136.34.16c.148.02.304.02.328.02.02 0 .068-.216.044-.364-.08-.48-.52-.588-.52-.588s.132.292.068.428c-.092.192-.26.344-.26.344"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M174.252 740.932s.192.136.34.16c.148.02.304.02.328.02.02 0 .068-.216.044-.364-.08-.48-.52-.588-.52-.588s.132.292.068.428c-.092.192-.26.344-.26.344z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M173.336 741.348s-.172-.308-.532-.268c-.36.044-.6.324-.6.324s.4-.012.5.052c.148.096.192.344.192.344s.216-.128.284-.216c.064-.084.156-.236.156-.236"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M173.336 741.348s-.172-.308-.532-.268c-.36.044-.6.324-.6.324s.4-.012.5.052c.148.096.192.344.192.344s.216-.128.284-.216c.064-.084.156-.236.156-.236z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M172.896 742.6s-.308.044-.476.236c-.172.196-.144.56-.144.56s.2-.216.38-.216c.184 0 .464.064.464.064s-.088-.224-.088-.32-.136-.324-.136-.324"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M172.896 742.6s-.308.044-.476.236c-.172.196-.144.56-.144.56s.2-.216.38-.216c.184 0 .464.064.464.064s-.088-.224-.088-.32-.136-.324-.136-.324z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.732 742.556.132-.212.136.196-.268.016"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m178.732 742.556.132-.212.136.196-.268.016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.056 742.548.16-.212.172.192-.332.02"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m179.056 742.548.16-.212.172.192-.332.02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.912 741.232.328.116-.296.152-.032-.268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m178.912 741.232.328.116-.296.152-.032-.268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.308 741.34.292.072-.236.184-.056-.256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m179.308 741.34.292.072-.236.184-.056-.256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M177.1 743.856s-.32.092-.44.268c-.148.212-.136.428-.136.428s.272-.224.624-.132c.348.096.384.132.532.12.148-.012.508-.14.508-.14s-.296.344-.26.58c.032.232.076.34.068.46-.024.288-.24.644-.24.644s.124-.076.42-.14a1.84 1.84 0 0 0 .7-.324c.156-.116.36-.408.36-.408s-.064.4 0 .568c.068.176.092.668.092.668s.188-.168.34-.248c.076-.044.28-.152.36-.28.056-.088.128-.424.128-.424s.044.36.156.536c.112.168.28.696.28.696s.116-.344.24-.484c.124-.14.272-.32.28-.428.012-.108-.032-.34-.032-.34l.156.34m-4.564.244s.192-.332.372-.44c.184-.104.432-.296.5-.32.064-.02.36-.184.36-.184m.396 2.068s.436-.22.564-.3c.272-.16.464-.448.464-.448"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M173.924 746.648s-.168-.18-.464-.128c-.296.056-.488.388-.488.388s.252-.068.4-.032c.144.032.248.18.248.18s.136-.116.18-.18c.044-.064.124-.228.124-.228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M173.924 746.648s-.168-.18-.464-.128c-.296.056-.488.388-.488.388s.252-.068.4-.032c.144.032.248.18.248.18s.136-.116.18-.18c.044-.064.124-.228.124-.228z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M173.584 747.836s-.248-.04-.464.132c-.212.172-.224.5-.224.5s.204-.172.364-.148c.156.02.348.108.348.108s.032-.204.044-.256c.036-.152-.068-.336-.068-.336"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M173.584 747.836s-.248-.04-.464.132c-.212.172-.224.5-.224.5s.204-.172.364-.148c.156.02.348.108.348.108s.032-.204.044-.256c.036-.152-.068-.336-.068-.336z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M174.164 748.932s-.02.316.132.512c.16.204.452.236.452.236s-.096-.212-.112-.32c-.024-.16.136-.3.136-.3s-.148-.152-.292-.152c-.148 0-.316.024-.316.024"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M174.164 748.932s-.02.316.132.512c.16.204.452.236.452.236s-.096-.212-.112-.32c-.024-.16.136-.3.136-.3s-.148-.152-.292-.152c-.148 0-.316.024-.316.024zM180.832 749.464s.816.504.792.924c-.024.416-.452.964-.452.964"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M177.1 751.748s-.204-.256-.484-.248c-.284.012-.58.276-.58.276s.352-.028.444.088c.092.12.18.268.18.268s.16-.084.228-.14c.068-.052.212-.244.212-.244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M177.1 751.748s-.204-.256-.484-.248c-.284.012-.58.276-.58.276s.352-.028.444.088c.092.12.18.268.18.268s.16-.084.228-.14c.068-.052.212-.244.212-.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M176.232 752.872s-.372-.056-.556.14c-.18.192-.168.544-.168.544s.224-.244.428-.224c.204.02.432.128.432.128s-.036-.212-.06-.312a4.115 4.115 0 0 0-.076-.276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M176.232 752.872s-.372-.056-.556.14c-.18.192-.168.544-.168.544s.224-.244.428-.224c.204.02.432.128.432.128s-.036-.212-.06-.312a4.115 4.115 0 0 0-.076-.276z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M177.036 754.06s-.184.256-.048.46c.136.204.42.3.42.3s-.104-.148-.056-.32c.036-.136.268-.32.268-.32l-.584-.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M177.036 754.06s-.184.256-.048.46c.136.204.42.3.42.3s-.104-.148-.056-.32c.036-.136.268-.32.268-.32l-.584-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M181.996 754.544s-.324-.076-.508.032c-.18.104-.328.556-.328.556s.296-.248.512-.216c.212.032.372.12.372.12s.032-.184.008-.312a.97.97 0 0 0-.056-.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M181.996 754.544s-.324-.076-.508.032c-.18.104-.328.556-.328.556s.296-.248.512-.216c.212.032.372.12.372.12s.032-.184.008-.312a.97.97 0 0 0-.056-.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M182.156 755.74s-.248.256-.16.472c.092.216.248.44.248.44s-.008-.32.092-.408c.148-.128.42-.148.42-.148s-.216-.192-.284-.216c-.068-.02-.316-.14-.316-.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M182.156 755.74s-.248.256-.16.472c.092.216.248.44.248.44s-.008-.32.092-.408c.148-.128.42-.148.42-.148s-.216-.192-.284-.216c-.068-.02-.316-.14-.316-.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB4446",
    d: "M183.4 756.116s-.124.312.112.512c.236.208.444.228.444.228s-.184-.324-.128-.492c.06-.18.216-.288.216-.288s-.296-.1-.34-.088a3.703 3.703 0 0 0-.304.128"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M183.4 756.116s-.124.312.112.512c.236.208.444.228.444.228s-.184-.324-.128-.492c.06-.18.216-.288.216-.288s-.296-.1-.34-.088a3.703 3.703 0 0 0-.304.128z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD691",
    stroke: "#000",
    strokeWidth: 0.208,
    d: "M170.664 778.32c.836.252 1.26.876 1.26 1.604 0 .952-.92 1.672-2.12 1.672-1.196 0-2.168-.72-2.168-1.672 0-.716.4-1.52 1.232-1.576 0 0-.024-.076-.096-.2l-.256-.264s.316-.06.5.008c.184.072.308.188.308.188s.084-.172.208-.304c.12-.132.28-.212.28-.212s.184.152.244.256c.06.108.1.236.1.236s.168-.14.316-.196c.148-.06.336-.104.336-.104s-.052.184-.088.276a1.518 1.518 0 0 0-.056.288"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    stroke: "#000",
    strokeWidth: 0.208,
    d: "M169.628 782.628s-1.592-1.072-2.28-1.216c-.884-.188-1.876-.036-2.304-.06.012.012.516.372.736.592.22.22.956.66 1.372.764 1.288.324 2.476-.08 2.476-.08M170.084 782.724s1.016-1.064 2.084-1.208c1.26-.176 2.088.104 2.576.232.012 0-.404.196-.624.348-.22.148-.788.628-1.656.636-.872.012-1.832-.092-1.988-.068l-.392.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    stroke: "#000",
    strokeWidth: 0.208,
    d: "M169.776 781.412a2.023 2.023 0 0 1 .004-2.972 2.032 2.032 0 0 1-.004 2.972"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058E6E",
    stroke: "#000",
    strokeWidth: 0.208,
    d: "M169.372 783.584s.244-.608.268-1.132c.024-.436-.06-.868-.06-.868h.32s.156.464.156.868c0 .408-.072.948-.072.948s-.22.032-.292.068c-.076.036-.32.116-.32.116"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M189.5 725.968c0-.228.2-.412.44-.412.244 0 .44.184.44.412a.426.426 0 0 1-.44.416c-.24 0-.44-.184-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M189.5 725.968c0-.228.2-.412.44-.412.244 0 .44.184.44.412a.426.426 0 0 1-.44.416c-.24 0-.44-.184-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M190.1 724.908c0-.228.196-.416.44-.416.24 0 .436.188.436.416a.425.425 0 0 1-.436.416.426.426 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M190.1 724.908c0-.228.196-.416.44-.416.24 0 .436.188.436.416a.425.425 0 0 1-.436.416.426.426 0 0 1-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M190.5 723.676c0-.228.196-.412.44-.412.24 0 .44.184.44.412 0 .232-.2.416-.44.416a.426.426 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M190.5 723.676c0-.228.196-.412.44-.412.24 0 .44.184.44.412 0 .232-.2.416-.44.416a.426.426 0 0 1-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M190.552 722.356c0-.228.196-.412.436-.412.244 0 .44.184.44.412a.426.426 0 0 1-.44.416.425.425 0 0 1-.436-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M190.552 722.356c0-.228.196-.412.436-.412.244 0 .44.184.44.412a.426.426 0 0 1-.44.416.425.425 0 0 1-.436-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M190.228 721.06c0-.232.196-.416.436-.416.244 0 .44.184.44.416a.429.429 0 0 1-.44.416.428.428 0 0 1-.436-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M190.228 721.06c0-.232.196-.416.436-.416.244 0 .44.184.44.416a.429.429 0 0 1-.44.416.428.428 0 0 1-.436-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M189.552 719.88c0-.232.196-.416.436-.416.244 0 .44.184.44.416a.429.429 0 0 1-.44.416.428.428 0 0 1-.436-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M189.552 719.88c0-.232.196-.416.436-.416.244 0 .44.184.44.416a.429.429 0 0 1-.44.416.428.428 0 0 1-.436-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M188.652 718.908c0-.228.196-.416.436-.416.244 0 .44.188.44.416a.426.426 0 0 1-.44.416.425.425 0 0 1-.436-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M188.652 718.908c0-.228.196-.416.436-.416.244 0 .44.188.44.416a.426.426 0 0 1-.44.416.425.425 0 0 1-.436-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M187.604 718.104c0-.228.2-.416.44-.416.244 0 .44.188.44.416a.429.429 0 0 1-.44.416c-.24 0-.44-.188-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M187.604 718.104c0-.228.2-.416.44-.416.244 0 .44.188.44.416a.429.429 0 0 1-.44.416c-.24 0-.44-.188-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M186.356 717.444c0-.228.196-.412.44-.412.24 0 .44.184.44.412 0 .232-.2.416-.44.416a.426.426 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M186.356 717.444c0-.228.196-.412.44-.412.24 0 .44.184.44.412 0 .232-.2.416-.44.416a.426.426 0 0 1-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M185.06 716.976c0-.228.196-.416.44-.416.24 0 .44.188.44.416 0 .228-.2.416-.44.416a.429.429 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M185.06 716.976c0-.228.196-.416.44-.416.24 0 .44.188.44.416 0 .228-.2.416-.44.416a.429.429 0 0 1-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M183.612 716.716c0-.228.196-.416.44-.416.24 0 .436.188.436.416a.428.428 0 0 1-.436.416.429.429 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M183.612 716.716c0-.228.196-.416.44-.416.24 0 .436.188.436.416a.428.428 0 0 1-.436.416.429.429 0 0 1-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M182.236 716.644c0-.228.196-.412.44-.412.24 0 .44.184.44.412 0 .232-.2.416-.44.416a.426.426 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M182.236 716.644c0-.228.196-.412.44-.412.24 0 .44.184.44.412 0 .232-.2.416-.44.416a.426.426 0 0 1-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M180.888 716.692c0-.228.196-.416.44-.416.24 0 .436.188.436.416a.428.428 0 0 1-.436.416.429.429 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M180.888 716.692c0-.228.196-.416.44-.416.24 0 .436.188.436.416a.428.428 0 0 1-.436.416.429.429 0 0 1-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M179.54 716.692c0-.228.196-.416.436-.416.244 0 .44.188.44.416a.429.429 0 0 1-.44.416.428.428 0 0 1-.436-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M179.54 716.692c0-.228.196-.416.436-.416.244 0 .44.188.44.416a.429.429 0 0 1-.44.416.428.428 0 0 1-.436-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M180.212 717.848c0-.228.2-.416.44-.416.244 0 .436.188.436.416a.425.425 0 0 1-.436.416c-.24 0-.44-.188-.44-.416M180.488 719.128c0-.232.196-.416.44-.416.24 0 .436.184.436.416 0 .228-.196.412-.436.412-.244 0-.44-.184-.44-.412M180.536 720.4c0-.228.2-.416.44-.416.244 0 .44.188.44.416a.429.429 0 0 1-.44.416c-.24 0-.44-.188-.44-.416M180.14 721.56c0-.228.196-.416.436-.416.244 0 .44.188.44.416a.426.426 0 0 1-.44.416.425.425 0 0 1-.436-.416M179.392 722.628c0-.232.196-.416.44-.416.24 0 .436.184.436.416 0 .228-.196.412-.436.412-.244 0-.44-.184-.44-.412"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M178.516 715.888c0-.228.2-.412.44-.412.244 0 .44.184.44.412a.429.429 0 0 1-.44.416c-.24 0-.44-.188-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M178.516 715.888c0-.228.2-.412.44-.412.244 0 .44.184.44.412a.429.429 0 0 1-.44.416c-.24 0-.44-.188-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M177.32 715.224c0-.228.196-.416.436-.416.244 0 .44.188.44.416a.426.426 0 0 1-.44.416.425.425 0 0 1-.436-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M177.32 715.224c0-.228.196-.416.436-.416.244 0 .44.188.44.416a.426.426 0 0 1-.44.416.425.425 0 0 1-.436-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M175.996 714.828c0-.232.2-.416.44-.416.244 0 .44.184.44.416a.429.429 0 0 1-.44.416c-.24 0-.44-.188-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M175.996 714.828c0-.232.2-.416.44-.416.244 0 .44.184.44.416a.429.429 0 0 1-.44.416c-.24 0-.44-.188-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M174.624 714.592c0-.228.196-.416.436-.416.244 0 .44.188.44.416 0 .228-.196.412-.44.412-.24 0-.436-.184-.436-.412"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M174.624 714.592c0-.228.196-.416.436-.416.244 0 .44.188.44.416 0 .228-.196.412-.44.412-.24 0-.436-.184-.436-.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M173.28 714.612c0-.228.196-.416.436-.416.244 0 .44.188.44.416a.426.426 0 0 1-.44.416.425.425 0 0 1-.436-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M173.28 714.612c0-.228.196-.416.436-.416.244 0 .44.188.44.416a.426.426 0 0 1-.44.416.425.425 0 0 1-.436-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M171.88 714.848c0-.228.196-.412.436-.412.244 0 .44.184.44.412a.426.426 0 0 1-.44.416.425.425 0 0 1-.436-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M171.88 714.848c0-.228.196-.412.436-.412.244 0 .44.184.44.412a.426.426 0 0 1-.44.416.425.425 0 0 1-.436-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M170.584 715.296c0-.228.196-.416.436-.416.244 0 .44.188.44.416a.429.429 0 0 1-.44.416.428.428 0 0 1-.436-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M170.584 715.296c0-.228.196-.416.436-.416.244 0 .44.188.44.416a.429.429 0 0 1-.44.416.428.428 0 0 1-.436-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M148.636 725.968c0-.228.196-.412.44-.412.24 0 .436.184.436.412a.425.425 0 0 1-.436.416.426.426 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M148.636 725.968c0-.228.196-.412.44-.412.24 0 .436.184.436.412a.425.425 0 0 1-.436.416.426.426 0 0 1-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M148.036 724.908c0-.228.196-.416.44-.416.24 0 .44.188.44.416 0 .232-.2.416-.44.416a.426.426 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M148.036 724.908c0-.228.196-.416.44-.416.24 0 .44.188.44.416 0 .232-.2.416-.44.416a.426.426 0 0 1-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M147.636 723.676c0-.228.196-.412.44-.412.24 0 .44.184.44.412 0 .232-.2.416-.44.416a.426.426 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M147.636 723.676c0-.228.196-.412.44-.412.24 0 .44.184.44.412 0 .232-.2.416-.44.416a.426.426 0 0 1-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M147.588 722.356c0-.228.196-.412.436-.412.244 0 .44.184.44.412a.426.426 0 0 1-.44.416.425.425 0 0 1-.436-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M147.588 722.356c0-.228.196-.412.436-.412.244 0 .44.184.44.412a.426.426 0 0 1-.44.416.425.425 0 0 1-.436-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M147.912 721.06c0-.232.196-.416.436-.416.244 0 .44.184.44.416a.429.429 0 0 1-.44.416.428.428 0 0 1-.436-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M147.912 721.06c0-.232.196-.416.436-.416.244 0 .44.184.44.416a.429.429 0 0 1-.44.416.428.428 0 0 1-.436-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M148.584 719.88c0-.232.2-.416.44-.416.244 0 .44.184.44.416a.429.429 0 0 1-.44.416c-.24 0-.44-.188-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M148.584 719.88c0-.232.2-.416.44-.416.244 0 .44.184.44.416a.429.429 0 0 1-.44.416c-.24 0-.44-.188-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M149.484 718.908c0-.228.2-.416.44-.416.244 0 .44.188.44.416a.426.426 0 0 1-.44.416c-.24 0-.44-.184-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M149.484 718.908c0-.228.2-.416.44-.416.244 0 .44.188.44.416a.426.426 0 0 1-.44.416c-.24 0-.44-.184-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M150.532 718.104c0-.228.196-.416.44-.416.24 0 .436.188.436.416a.428.428 0 0 1-.436.416.429.429 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M150.532 718.104c0-.228.196-.416.44-.416.24 0 .436.188.436.416a.428.428 0 0 1-.436.416.429.429 0 0 1-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M151.78 717.444c0-.228.196-.412.44-.412.24 0 .44.184.44.412 0 .232-.2.416-.44.416a.426.426 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M151.78 717.444c0-.228.196-.412.44-.412.24 0 .44.184.44.412 0 .232-.2.416-.44.416a.426.426 0 0 1-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M153.076 716.976c0-.228.196-.416.44-.416.24 0 .436.188.436.416a.428.428 0 0 1-.436.416.429.429 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M153.076 716.976c0-.228.196-.416.44-.416.24 0 .436.188.436.416a.428.428 0 0 1-.436.416.429.429 0 0 1-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M154.528 716.716c0-.228.196-.416.436-.416s.44.188.44.416c0 .228-.2.416-.44.416a.428.428 0 0 1-.436-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M154.528 716.716c0-.228.196-.416.436-.416s.44.188.44.416c0 .228-.2.416-.44.416a.428.428 0 0 1-.436-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M155.9 716.644c0-.228.196-.412.44-.412.24 0 .44.184.44.412 0 .232-.2.416-.44.416a.426.426 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M155.9 716.644c0-.228.196-.412.44-.412.24 0 .44.184.44.412 0 .232-.2.416-.44.416a.426.426 0 0 1-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M157.252 716.692c0-.228.196-.416.436-.416.244 0 .44.188.44.416a.429.429 0 0 1-.44.416.428.428 0 0 1-.436-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M157.252 716.692c0-.228.196-.416.436-.416.244 0 .44.188.44.416a.429.429 0 0 1-.44.416.428.428 0 0 1-.436-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M158.6 716.692c0-.228.196-.416.436-.416.244 0 .44.188.44.416a.429.429 0 0 1-.44.416.428.428 0 0 1-.436-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M158.6 716.692c0-.228.196-.416.436-.416.244 0 .44.188.44.416a.429.429 0 0 1-.44.416.428.428 0 0 1-.436-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M157.924 717.848c0-.228.196-.416.44-.416.24 0 .44.188.44.416 0 .228-.2.416-.44.416a.429.429 0 0 1-.44-.416M157.652 719.128c0-.232.192-.416.436-.416s.44.184.44.416c0 .228-.196.412-.44.412a.422.422 0 0 1-.436-.412M157.6 720.4c0-.228.196-.416.44-.416.24 0 .436.188.436.416a.428.428 0 0 1-.436.416.429.429 0 0 1-.44-.416M158 721.56c0-.228.196-.416.436-.416.244 0 .44.188.44.416a.426.426 0 0 1-.44.416.425.425 0 0 1-.436-.416M158.744 722.628c0-.232.2-.416.44-.416.244 0 .44.184.44.416 0 .228-.196.412-.44.412-.24 0-.44-.184-.44-.412"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M159.62 715.888c0-.228.196-.412.44-.412.24 0 .436.184.436.412a.428.428 0 0 1-.436.416.429.429 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M159.62 715.888c0-.228.196-.412.44-.412.24 0 .436.184.436.412a.428.428 0 0 1-.436.416.429.429 0 0 1-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M160.82 715.224c0-.228.196-.416.436-.416.244 0 .44.188.44.416a.426.426 0 0 1-.44.416.425.425 0 0 1-.436-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M160.82 715.224c0-.228.196-.416.436-.416.244 0 .44.188.44.416a.426.426 0 0 1-.44.416.425.425 0 0 1-.436-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M162.14 714.828c0-.232.196-.416.44-.416.24 0 .436.184.436.416a.428.428 0 0 1-.436.416.429.429 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M162.14 714.828c0-.232.196-.416.44-.416.24 0 .436.184.436.416a.428.428 0 0 1-.436.416.429.429 0 0 1-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M163.516 714.592c0-.228.196-.416.436-.416.244 0 .44.188.44.416 0 .228-.196.412-.44.412-.24 0-.436-.184-.436-.412"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M163.516 714.592c0-.228.196-.416.436-.416.244 0 .44.188.44.416 0 .228-.196.412-.44.412-.24 0-.436-.184-.436-.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M164.86 714.612c0-.228.196-.416.44-.416.24 0 .436.188.436.416a.425.425 0 0 1-.436.416.426.426 0 0 1-.44-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M164.86 714.612c0-.228.196-.416.44-.416.24 0 .436.188.436.416a.425.425 0 0 1-.436.416.426.426 0 0 1-.44-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M166.26 714.848c0-.228.196-.412.436-.412.244 0 .44.184.44.412a.426.426 0 0 1-.44.416.425.425 0 0 1-.436-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M166.26 714.848c0-.228.196-.412.436-.412.244 0 .44.184.44.412a.426.426 0 0 1-.44.416.425.425 0 0 1-.436-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M167.556 715.296c0-.228.192-.416.436-.416s.44.188.44.416a.429.429 0 0 1-.44.416.425.425 0 0 1-.436-.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.156,
    d: "M167.556 715.296c0-.228.192-.416.436-.416s.44.188.44.416a.429.429 0 0 1-.44.416.425.425 0 0 1-.436-.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    stroke: "#000",
    strokeWidth: 0.184,
    d: "M156.436 741.864h-.368v-.368h-.648v1.476h.648v1.02h-1.388v2.956h.74v5.916h-1.48v3.052h11.368v-3.052h-1.476v-5.916h.74v-2.956h-1.388v-1.02h.648v-1.476h-.648v.368h-.372v-.368h-.644v.368h-.464v-.368h-.648v1.476h.648v1.02h-1.384v-3.236h.736v-1.48h-.736v.372h-.372v-.372h-.648v.372h-.368v-.372h-.74v1.48h.74v3.236h-1.388v-1.02h.648v-1.476h-.648v.368h-.368v-.368h-.74v.368zm-2.496 14.052h11.368m-11.368-.74h11.368m-11.368-.74h11.368m-11.368-.74h11.368m-11.368-.832h11.368m-9.888-.648h8.412m-8.412-.74h8.412m-8.412-.832h8.412m-8.412-.736h8.412m-8.412-.74h8.412m-8.412-.74h8.412m-8.412-.74h8.412m-9.152-.74h9.892m-9.892-.74h9.892m-9.892-.74h9.892m-9.892-.736h9.892m-8.504-.74h7.116m-4.252-.74h1.388m-1.388-.74h1.388m-1.388-.74h1.388m-1.388-.74h1.388m-2.128-.924h2.864m-4.988 3.144h1.476m-2.124-.924h2.772m-2.772 13.588v-.74m0-.74v-.74m-.74.74v.74m1.388 0v-.74m.736 1.48v-.74m0-.74v-.74m0-.832v-.648m0-.74v-.832m-.736 3.052v-.832m-1.388.832v-.832m2.864 0v.832m.648-.832v-.648m-2.124-.74v.74m1.476-.74v.74m1.388-.74v.74m-.74-.74v-.832m.74-.736v.736m0-2.216v.74m-.74-1.48v.74m.74-1.48v.74m-1.388-.74v.74m-1.476-.74v.74m-.648-1.48v.74m1.384-.74v.74m1.388-.74v.74m.74-1.48v.74m-1.388-.74v.74m-1.476-.74v.74m-.648-1.476v.736m2.772-.736v.736m-1.388-2.216v.74m6.38-.74h-1.48m2.128-.924h-2.776m2.776 13.588v-.74m0-.74v-.74m.74.74v.74m-1.388 0v-.74m-.74 1.48v-.74m0-.74v-.74m0-.832v-.648m0-.74v-.832m.74 3.052v-.832m1.388.832v-.832m-2.868 0v.832m-.648-.832v-.648m2.128-.74v.74m-1.48-.74v.74m-1.384-.74v.74m.736-.74v-.832m-.736-.736v.736m0-2.216v.74m.736-1.48v.74m-.736-1.48v.74m1.384-.74v.74m1.48-.74v.74m.648-1.48v.74m-1.388-.74v.74m-1.388-.74v.74m-.736-1.48v.74m1.384-.74v.74m1.48-.74v.74m.648-1.476v.736m-2.776-.736v.736m1.388-2.216v.74m-2.864 7.484v-.832m0-2.216v-.74m0 2.22v-.74m0-2.22v-.74m0-.74v-.736m0-1.48v-.74m0-.74v-.74m-3.512 1.94h1.476m1.388-2.216h1.388m1.384 2.216h1.48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    stroke: "#000",
    strokeWidth: 0.184,
    d: "M161.52 755.916v-1.944c0-.368-.184-1.48-1.94-1.48-1.664 0-1.848 1.112-1.848 1.48v1.944h3.788z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    stroke: "#000",
    strokeWidth: 0.184,
    d: "m158.376 754.064-.924-.092c0-.368.092-.924.372-1.108l.832.648c-.092.092-.28.368-.28.552zM160.872 754.064l.924-.092c0-.368-.092-.924-.368-1.108l-.832.648c.092.092.276.368.276.552zM159.948 753.14l.464-.832a2.219 2.219 0 0 0-.832-.184c-.184 0-.556.092-.74.184l.46.832h.648zM158.192 750.832v-2.036c0-.552-.368-1.016-1.016-1.016s-1.016.464-1.016 1.016v2.036h2.032zM161.056 750.832v-2.036c0-.552.372-1.016 1.02-1.016.644 0 1.016.464 1.016 1.016v2.036h-2.036zM160.32 745.84l.184-1.848h-1.756l.092 1.848h1.48zM161.704 745.84l-.184-1.848h1.848l-.184 1.848h-1.48zM157.544 745.84l.092-1.848h-1.756l.188 1.848h1.476z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0039F0",
    d: "M160.872 755.916v-1.664c0-.28-.184-1.112-1.292-1.112-1.016 0-1.204.832-1.204 1.112v1.664h2.496zM158.008 750.644v-1.756c0-.46-.276-.924-.832-.924-.556 0-.832.464-.832.924v1.756h1.664zM161.244 750.644v-1.756c0-.46.276-.924.832-.924.552 0 .832.464.832.924v1.756h-1.664z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AD1519",
    d: "M163.172 758.904c0-4.044 2.908-7.32 6.5-7.32s6.504 3.276 6.504 7.32c0 4.04-2.912 7.316-6.504 7.316-3.592 0-6.5-3.276-6.5-7.316"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.244,
    d: "M163.172 758.904c0-4.044 2.908-7.32 6.5-7.32s6.504 3.276 6.504 7.32c0 4.04-2.912 7.316-6.504 7.316-3.592 0-6.5-3.276-6.5-7.316z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005BBF",
    d: "M165.1 758.888c0-2.964 2.048-5.364 4.576-5.364 2.524 0 4.572 2.4 4.572 5.364s-2.048 5.368-4.572 5.368c-2.528 0-4.576-2.404-4.576-5.368"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.244,
    d: "M165.1 758.888c0-2.964 2.048-5.364 4.576-5.364 2.524 0 4.572 2.4 4.572 5.364s-2.048 5.368-4.572 5.368c-2.528 0-4.576-2.404-4.576-5.368z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M167.512 755.196s-.54.592-.54 1.144c0 .556.228 1.016.228 1.016a.598.598 0 0 0-.564-.376c-.332 0-.6.252-.6.568 0 .088.056.232.096.308l.196.396c.064-.148.216-.228.392-.228.236 0 .432.18.432.404a.276.276 0 0 1-.016.1l-.488.004v.412h.436l-.324.644.428-.168.324.364.336-.364.428.168-.32-.644h.432v-.412l-.488-.004c-.008-.032-.008-.064-.008-.1 0-.224.188-.404.424-.404.176 0 .328.08.392.228l.196-.396a.839.839 0 0 0 .096-.308.582.582 0 0 0-.596-.568.59.59 0 0 0-.564.376s.228-.46.228-1.016c0-.552-.556-1.144-.556-1.144"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.136,
    strokeLinejoin: "round",
    d: "M167.512 755.196s-.54.592-.54 1.144c0 .556.228 1.016.228 1.016a.598.598 0 0 0-.564-.376c-.332 0-.6.252-.6.568 0 .088.056.232.096.308l.196.396c.064-.148.216-.228.392-.228.236 0 .432.18.432.404a.276.276 0 0 1-.016.1l-.488.004v.412h.436l-.324.644.428-.168.324.364.336-.364.428.168-.32-.644h.432v-.412l-.488-.004c-.008-.032-.008-.064-.008-.1 0-.224.188-.404.424-.404.176 0 .328.08.392.228l.196-.396a.839.839 0 0 0 .096-.308.582.582 0 0 0-.596-.568.59.59 0 0 0-.564.376s.228-.46.228-1.016c0-.552-.556-1.144-.556-1.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M166.648 758.944h1.744v-.412h-1.744v.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.136,
    d: "M166.648 758.944h1.744v-.412h-1.744v.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M171.764 755.196s-.54.592-.54 1.144c0 .556.228 1.016.228 1.016a.598.598 0 0 0-.564-.376c-.332 0-.6.252-.6.568 0 .088.056.232.096.308l.196.396c.064-.148.216-.228.392-.228.24 0 .428.18.428.404a.403.403 0 0 1-.012.1l-.488.004v.412h.436l-.324.644.428-.168.324.364.336-.364.428.168-.324-.644h.436v-.412l-.488-.004a.403.403 0 0 1-.012-.1c0-.224.192-.404.428-.404.176 0 .328.08.392.228l.196-.396a.839.839 0 0 0 .096-.308.582.582 0 0 0-.596-.568.603.603 0 0 0-.568.376s.232-.46.232-1.016c0-.552-.556-1.144-.556-1.144"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.136,
    strokeLinejoin: "round",
    d: "M171.764 755.196s-.54.592-.54 1.144c0 .556.228 1.016.228 1.016a.598.598 0 0 0-.564-.376c-.332 0-.6.252-.6.568 0 .088.056.232.096.308l.196.396c.064-.148.216-.228.392-.228.24 0 .428.18.428.404a.403.403 0 0 1-.012.1l-.488.004v.412h.436l-.324.644.428-.168.324.364.336-.364.428.168-.324-.644h.436v-.412l-.488-.004a.403.403 0 0 1-.012-.1c0-.224.192-.404.428-.404.176 0 .328.08.392.228l.196-.396a.839.839 0 0 0 .096-.308.582.582 0 0 0-.596-.568.603.603 0 0 0-.568.376s.232-.46.232-1.016c0-.552-.556-1.144-.556-1.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M170.9 758.944h1.74v-.412h-1.74v.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.136,
    d: "M170.9 758.944h1.74v-.412h-1.74v.412z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M169.64 758.852s-.544.596-.544 1.148.228 1.012.228 1.012a.6.6 0 0 0-.564-.376c-.332 0-.6.252-.6.568 0 .092.056.232.1.312l.192.392c.068-.144.216-.228.396-.228.236 0 .428.18.428.408a.276.276 0 0 1-.016.1h-.484v.416h.436l-.324.64.428-.168.324.364.336-.364.428.168-.328-.64h.44v-.416h-.488a.414.414 0 0 1 .416-.508c.176 0 .324.084.392.228l.196-.392c.04-.08.096-.22.096-.312 0-.316-.268-.568-.6-.568-.26 0-.48.16-.564.376 0 0 .228-.46.228-1.012s-.556-1.148-.556-1.148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.136,
    strokeLinejoin: "round",
    d: "M169.64 758.852s-.544.596-.544 1.148.228 1.012.228 1.012a.6.6 0 0 0-.564-.376c-.332 0-.6.252-.6.568 0 .092.056.232.1.312l.192.392c.068-.144.216-.228.396-.228.236 0 .428.18.428.408a.276.276 0 0 1-.016.1h-.484v.416h.436l-.324.64.428-.168.324.364.336-.364.428.168-.328-.64h.44v-.416h-.488a.414.414 0 0 1 .416-.508c.176 0 .324.084.392.228l.196-.392c.04-.08.096-.22.096-.312 0-.316-.268-.568-.6-.568-.26 0-.48.16-.564.376 0 0 .228-.46.228-1.012s-.556-1.148-.556-1.148h.004z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M168.776 762.604h1.74v-.416h-1.74v.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.136,
    d: "M168.776 762.604h1.74v-.416h-1.74v.416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m182.652 739.584-.116.008a.597.597 0 0 1-.104.14c-.104.1-.26.112-.344.028a.194.194 0 0 1-.056-.164.197.197 0 0 1-.204-.004c-.104-.06-.128-.2-.056-.316.012-.024.024-.056.044-.072l-.008-.128-.14.032-.04.076c-.088.1-.216.124-.28.068a.21.21 0 0 1-.052-.108.148.148 0 0 1-.068.044c-.216.052-.3-.42-.308-.54l-.068.1s.064.28.032.52c-.032.236-.116.476-.116.476.296.076.744.32 1.188.66.444.34.792.712.936.968 0 0 .232-.128.472-.204.24-.076.544-.08.544-.08l.088-.084c-.128.02-.632.04-.624-.172 0-.032.028-.072.032-.072a.279.279 0 0 1-.12-.024c-.072-.052-.072-.172.008-.276l.072-.052.004-.136-.136.02c-.012.016-.044.036-.06.052-.108.092-.26.1-.344.012a.167.167 0 0 1-.044-.184.232.232 0 0 1-.18-.02c-.104-.06-.124-.208-.044-.32a.534.534 0 0 1 .124-.128l-.028-.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m182.652 739.584-.116.008a.597.597 0 0 1-.104.14c-.104.1-.26.112-.344.028a.194.194 0 0 1-.056-.164.197.197 0 0 1-.204-.004c-.104-.06-.128-.2-.056-.316.012-.024.024-.056.044-.072l-.008-.128-.14.032-.04.076c-.088.1-.216.124-.28.068a.21.21 0 0 1-.052-.108.148.148 0 0 1-.068.044c-.216.052-.3-.42-.308-.54l-.068.1s.064.28.032.52c-.032.236-.116.476-.116.476.296.076.744.32 1.188.66.444.34.792.712.936.968 0 0 .232-.128.472-.204.24-.076.544-.08.544-.08l.088-.084c-.128.02-.632.04-.624-.172 0-.032.028-.072.032-.072a.279.279 0 0 1-.12-.024c-.072-.052-.072-.172.008-.276l.072-.052.004-.136-.136.02c-.012.016-.044.036-.06.052-.108.092-.26.1-.344.012a.167.167 0 0 1-.044-.184.232.232 0 0 1-.18-.02c-.104-.06-.124-.208-.044-.32a.534.534 0 0 1 .124-.128l-.028-.12h-.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.752 739.86c.02-.028.06-.024.092 0s.04.064.024.084c-.02.024-.06.024-.096-.004-.028-.02-.04-.06-.02-.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.02,
    d: "M181.752 739.86c.02-.028.06-.024.092 0s.04.064.024.084c-.02.024-.06.024-.096-.004-.028-.02-.04-.06-.02-.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.132 740.176-.132-.1c-.024-.016-.028-.048-.016-.064.016-.016.048-.016.072 0l.132.104.132.1c.02.016.032.048.016.064s-.048.016-.072 0l-.132-.104"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.02,
    d: "m182.132 740.176-.132-.1c-.024-.016-.028-.048-.016-.064.016-.016.048-.016.072 0l.132.104.132.1c.02.016.032.048.016.064s-.048.016-.072 0l-.132-.104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.436 739.7-.104-.06c-.028-.016-.04-.048-.028-.068.012-.02.044-.024.068-.008l.104.064.104.06c.024.012.036.044.028.064-.012.02-.044.024-.068.008l-.104-.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.02,
    d: "m181.436 739.7-.104-.06c-.028-.016-.04-.048-.028-.068.012-.02.044-.024.068-.008l.104.064.104.06c.024.012.036.044.028.064-.012.02-.044.024-.068.008l-.104-.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.02 739.416c.02-.024.064-.024.096 0 .032.028.04.064.02.088-.02.02-.06.02-.092-.004s-.04-.06-.024-.084"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.02,
    d: "M181.02 739.416c.02-.024.064-.024.096 0 .032.028.04.064.02.088-.02.02-.06.02-.092-.004s-.04-.06-.024-.084z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.552 740.468c.02-.02.012-.056-.02-.084-.032-.024-.076-.024-.096 0-.016.02-.008.06.024.084.032.024.072.024.092 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.02,
    d: "M182.552 740.468c.02-.02.012-.056-.02-.084-.032-.024-.076-.024-.096 0-.016.02-.008.06.024.084.032.024.072.024.092 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.78 740.732.088.084c.02.02.052.028.072.012.016-.016.016-.044-.004-.064l-.084-.084-.088-.084c-.02-.02-.056-.028-.072-.012-.02.012-.016.044.004.064l.084.084"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.02,
    d: "m182.78 740.732.088.084c.02.02.052.028.072.012.016-.016.016-.044-.004-.064l-.084-.084-.088-.084c-.02-.02-.056-.028-.072-.012-.02.012-.016.044.004.064l.084.084"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.16 741.056c.02-.024.012-.06-.02-.084-.032-.028-.072-.028-.092-.004-.02.024-.012.06.02.088.032.02.072.024.092 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.02,
    d: "M183.16 741.056c.02-.024.012-.06-.02-.084-.032-.028-.072-.028-.092-.004-.02.024-.012.06.02.088.032.02.072.024.092 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m182.06 738.644-.236.004-.044.348.024.056.06-.004.304-.204-.108-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m182.06 738.644-.236.004-.044.348.024.056.06-.004.304-.204-.108-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m181.42 738.836-.008.216.368.048.06-.028-.008-.06-.212-.284-.2.108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m181.42 738.836-.008.216.368.048.06-.028-.008-.06-.212-.284-.2.108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m182.18 739.268-.196.108-.216-.284-.004-.06.056-.024.372.044-.012.216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m182.18 739.268-.196.108-.216-.284-.004-.06.056-.024.372.044-.012.216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M181.704 739a.115.115 0 0 1 .156-.036c.056.028.072.096.04.148s-.104.068-.156.036a.104.104 0 0 1-.04-.148"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M181.704 739a.115.115 0 0 1 .156-.036c.056.028.072.096.04.148s-.104.068-.156.036a.104.104 0 0 1-.04-.148z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M180.844 738.64c-.008.004-.052-.184-.104-.284a.621.621 0 0 0-.156-.172c.012-.02.168-.076.348.036.152.124-.012.348-.012.348s-.036.056-.076.072"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M180.844 738.64c-.008.004-.052-.184-.104-.284a.621.621 0 0 0-.156-.172c.012-.02.168-.076.348.036.152.124-.012.348-.012.348s-.036.056-.076.072z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m181.256 738.764-.168.148-.272-.24.024-.032.012-.06.368-.028.036.212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m181.256 738.764-.168.148-.272-.24.024-.032.012-.06.368-.028.036.212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M180.796 738.616c.02-.06.072-.092.112-.08.044.016.06.072.04.132-.02.06-.072.092-.116.08-.044-.016-.06-.072-.036-.132"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M180.796 738.616c.02-.06.072-.092.112-.08.044.016.06.072.04.132-.02.06-.072.092-.116.08-.044-.016-.06-.072-.036-.132z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m182.968 739.208-.236-.024-.1.34.02.056.06.004.332-.164-.076-.212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m182.968 739.208-.236-.024-.1.34.02.056.06.004.332-.164-.076-.212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m182.304 739.312-.04.216.36.092.06-.016.004-.056-.172-.316-.212.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m182.304 739.312-.04.216.36.092.06-.016.004-.056-.172-.316-.212.08"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m182.992 739.844-.212.08-.168-.312.004-.06.06-.012.356.092-.04.212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m182.992 739.844-.212.08-.168-.312.004-.06.06-.012.356.092-.04.212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M182.56 739.516a.118.118 0 0 1 .16-.016c.052.036.06.104.02.152-.04.048-.112.052-.164.016a.104.104 0 0 1-.016-.152"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M182.56 739.516a.118.118 0 0 1 .16-.016c.052.036.06.104.02.152-.04.048-.112.052-.164.016a.104.104 0 0 1-.016-.152z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m183.756 739.944.044.22-.348.12-.064-.016-.004-.056.144-.324.228.056"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m183.756 739.944.044.22-.348.12-.064-.016-.004-.056.144-.324.228.056"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m183.696 740.58-.224.052-.124-.332.016-.06.06-.008.34.14-.068.208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m183.696 740.58-.224.052-.124-.332.016-.06.06-.008.34.14-.068.208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m183.088 739.964-.072.208.34.136.064-.008.012-.056-.12-.332-.224.052"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m183.088 739.964-.072.208.34.136.064-.008.012-.056-.12-.332-.224.052"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M183.464 740.352a.109.109 0 0 0 .008-.156.127.127 0 0 0-.164-.008c-.044.044-.048.112-.004.156.04.044.116.048.16.008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M183.464 740.352a.109.109 0 0 0 .008-.156.127.127 0 0 0-.164-.008c-.044.044-.048.112-.004.156.04.044.116.048.16.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M184.016 741.072c0 .004.2.012.316.036.08.016.208.108.208.108.024-.016.048-.168-.112-.316-.156-.112-.352.088-.352.088s-.048.048-.06.084"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M184.016 741.072c0 .004.2.012.316.036.08.016.208.108.208.108.024-.016.048-.168-.112-.316-.156-.112-.352.088-.352.088s-.048.048-.06.084z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "m183.8 740.716-.116.184.304.204.036-.032.052-.016-.048-.352-.228.012"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "m183.8 740.716-.116.184.304.204.036-.032.052-.016-.048-.352-.228.012"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8B100",
    d: "M184.048 741.112c.056-.028.084-.088.06-.124-.024-.036-.088-.04-.144-.008-.056.032-.08.088-.056.124.02.036.084.04.14.008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.104,
    d: "M184.048 741.112c.056-.028.084-.088.06-.124-.024-.036-.088-.04-.144-.008-.056.032-.08.088-.056.124.02.036.084.04.14.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.12,
    d: "M199.952 731.956v.232h-1.012v-.232h.376v-.52h-.248v-.232h.248v-.232h.244v.232h.244v.232h-.244v.52h.392"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.008,
    d: "M139.676 736.96v-.508"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.012,
    d: "M139.536 736.96v-.508"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.016,
    d: "M139.408 736.96v-.508M139.276 736.96v-.508"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.02,
    d: "M139.164 736.96v-.508"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.024,
    d: "m138.944 736.932-.004-.46m.108.468v-.484"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.028,
    d: "M138.74 736.912v-.424m.104.436-.004-.452"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.032,
    d: "M138.468 736.888v-.372m.092.376v-.392m.092.408v-.408"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.036,
    d: "M138.376 736.884v-.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.04,
    d: "M138.288 736.868v-.34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.044,
    d: "M138.192 736.856v-.312"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.048,
    d: "m137.996 736.828-.004-.248m.104.264v-.28M137.896 736.808v-.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.052,
    d: "M137.804 736.792v-.184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.056,
    d: "M137.704 736.768v-.144"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.06,
    d: "M137.604 736.756v-.108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.072,
    d: "M137.496 736.732v-.052"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.004,
    d: "M140.22 736.932v-.464m-.232.48.004-.492m-.172.5v-.504"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.008,
    d: "M199.408 736.968v-.508"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.012,
    d: "M199.268 736.968v-.508"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.016,
    d: "M199.14 736.968v-.508M199.012 736.968v-.508"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.02,
    d: "M198.896 736.968v-.508"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.024,
    d: "m198.676 736.94-.004-.46m.108.468v-.484"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.028,
    d: "M198.476 736.92v-.424m.1.436-.004-.452"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.032,
    d: "M198.204 736.896v-.372m.088.38v-.392m.092.404v-.408"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.036,
    d: "M198.108 736.892v-.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.04,
    d: "M198.02 736.876v-.336"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.044,
    d: "M197.924 736.868v-.316"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.048,
    d: "m197.732 736.84-.004-.252m.1.264v-.28M197.628 736.816v-.216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.052,
    d: "M197.54 736.8v-.184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.056,
    d: "M197.44 736.776v-.144"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.06,
    d: "M197.336 736.764v-.108"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.072,
    d: "M197.228 736.74v-.052"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.004,
    d: "M199.956 736.94v-.464m-.232.48v-.492m-.172.5v-.504"
  })))));
};
export default SvgSpainFlag;